/* tslint:disable */
/* eslint-disable */
/**
 * Admin
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 *
 * @export
 * @interface CategoriesClubsCategoryIdManualClub
 */
export interface CategoriesClubsCategoryIdManualClub {
  /**
   *
   * @type {string}
   * @memberof CategoriesClubsCategoryIdManualClub
   */
  title?: string | null;
  /**
   *
   * @type {number}
   * @memberof CategoriesClubsCategoryIdManualClub
   */
  subscriptionPrice?: number | null;
  /**
   *
   * @type {CategoriesClubsCategoryIdManualClubOwner}
   * @memberof CategoriesClubsCategoryIdManualClub
   */
  owner?: CategoriesClubsCategoryIdManualClubOwner | null;
}
/**
 *
 * @export
 * @interface CategoriesClubsCategoryIdManualClubOwner
 */
export interface CategoriesClubsCategoryIdManualClubOwner {
  /**
   *
   * @type {number}
   * @memberof CategoriesClubsCategoryIdManualClubOwner
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof CategoriesClubsCategoryIdManualClubOwner
   */
  name?: string;
  /**
   *
   * @type {boolean}
   * @memberof CategoriesClubsCategoryIdManualClubOwner
   */
  isAvatar?: boolean;
  /**
   *
   * @type {InlineResponse200Avatar}
   * @memberof CategoriesClubsCategoryIdManualClubOwner
   */
  avatar?: InlineResponse200Avatar | null;
}
/**
 *
 * @export
 * @interface CategoriesClubsCategoryIdManualCreate
 */
export interface CategoriesClubsCategoryIdManualCreate {
  /**
   *
   * @type {number}
   * @memberof CategoriesClubsCategoryIdManualCreate
   */
  order?: number | null;
  /**
   *
   * @type {number}
   * @memberof CategoriesClubsCategoryIdManualCreate
   */
  id?: number;
}
/**
 *
 * @export
 * @interface CategoriesClubsCategoryIdManualDelete
 */
export interface CategoriesClubsCategoryIdManualDelete {
  /**
   *
   * @type {number}
   * @memberof CategoriesClubsCategoryIdManualDelete
   */
  id?: number;
}
/**
 *
 * @export
 * @interface CategoriesSpacesCategoryIdManualCreate
 */
export interface CategoriesSpacesCategoryIdManualCreate {
  /**
   *
   * @type {number}
   * @memberof CategoriesSpacesCategoryIdManualCreate
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof CategoriesSpacesCategoryIdManualCreate
   */
  order?: number | null;
}
/**
 *
 * @export
 * @interface CategoriesSpacesCategoryIdManualSpace
 */
export interface CategoriesSpacesCategoryIdManualSpace {
  /**
   *
   * @type {number}
   * @memberof CategoriesSpacesCategoryIdManualSpace
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof CategoriesSpacesCategoryIdManualSpace
   */
  expert?: number;
  /**
   *
   * @type {string}
   * @memberof CategoriesSpacesCategoryIdManualSpace
   */
  title?: string;
  /**
   *
   * @type {number}
   * @memberof CategoriesSpacesCategoryIdManualSpace
   */
  price?: number;
  /**
   *
   * @type {string}
   * @memberof CategoriesSpacesCategoryIdManualSpace
   */
  type?: CategoriesSpacesCategoryIdManualSpaceTypeEnum;
  /**
   *
   * @type {string}
   * @memberof CategoriesSpacesCategoryIdManualSpace
   */
  status?: CategoriesSpacesCategoryIdManualSpaceStatusEnum;
  /**
   *
   * @type {string}
   * @memberof CategoriesSpacesCategoryIdManualSpace
   */
  payment_type?: CategoriesSpacesCategoryIdManualSpacePaymentTypeEnum;
  /**
   *
   * @type {InlineResponse200Avatar}
   * @memberof CategoriesSpacesCategoryIdManualSpace
   */
  cover?: InlineResponse200Avatar | null;
}

export const CategoriesSpacesCategoryIdManualSpaceTypeEnum = {
  Post: 'post',
  Live: 'live',
  Challenge: 'challenge',
  Trailer: 'trailer',
  Channel: 'channel',
} as const;

export type CategoriesSpacesCategoryIdManualSpaceTypeEnum =
  typeof CategoriesSpacesCategoryIdManualSpaceTypeEnum[keyof typeof CategoriesSpacesCategoryIdManualSpaceTypeEnum];
export const CategoriesSpacesCategoryIdManualSpaceStatusEnum = {
  Draft: 'draft',
  Published: 'published',
} as const;

export type CategoriesSpacesCategoryIdManualSpaceStatusEnum =
  typeof CategoriesSpacesCategoryIdManualSpaceStatusEnum[keyof typeof CategoriesSpacesCategoryIdManualSpaceStatusEnum];
export const CategoriesSpacesCategoryIdManualSpacePaymentTypeEnum = {
  FixedPrice: 'fixed_price',
  FixedPriceSubscribersOnly: 'fixed_price_subscribers_only',
  SubscribersOnly: 'subscribers_only',
  Free: 'free',
  MonthlyPrice: 'monthly_price',
} as const;

export type CategoriesSpacesCategoryIdManualSpacePaymentTypeEnum =
  typeof CategoriesSpacesCategoryIdManualSpacePaymentTypeEnum[keyof typeof CategoriesSpacesCategoryIdManualSpacePaymentTypeEnum];

/**
 *
 * @export
 * @interface CreatorsCreatorIdChallengesConfig
 */
export interface CreatorsCreatorIdChallengesConfig {
  /**
   *
   * @type {CreatorsCreatorIdChallengesConfigChallenge}
   * @memberof CreatorsCreatorIdChallengesConfig
   */
  challenge?: CreatorsCreatorIdChallengesConfigChallenge | null;
}
/**
 *
 * @export
 * @interface CreatorsCreatorIdChallengesConfigChallenge
 */
export interface CreatorsCreatorIdChallengesConfigChallenge {
  /**
   *
   * @type {number}
   * @memberof CreatorsCreatorIdChallengesConfigChallenge
   */
  finishTimestamp?: number | null;
}
/**
 *
 * @export
 * @interface CreatorsCreatorIdChallengesMarketingPriceConfig
 */
export interface CreatorsCreatorIdChallengesMarketingPriceConfig {
  /**
   *
   * @type {number}
   * @memberof CreatorsCreatorIdChallengesMarketingPriceConfig
   */
  previousPrice?: number | null;
}
/**
 *
 * @export
 * @interface CreatorsCreatorIdLinksOrderLinks
 */
export interface CreatorsCreatorIdLinksOrderLinks {
  /**
   *
   * @type {number}
   * @memberof CreatorsCreatorIdLinksOrderLinks
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof CreatorsCreatorIdLinksOrderLinks
   */
  order?: number;
}
/**
 *
 * @export
 * @interface InlineObject
 */
export interface InlineObject {
  /**
   *
   * @type {number}
   * @memberof InlineObject
   */
  realUserId?: number;
}
/**
 *
 * @export
 * @interface InlineObject1
 */
export interface InlineObject1 {
  /**
   *
   * @type {number}
   * @memberof InlineObject1
   */
  spaceId?: number;
  /**
   *
   * @type {number}
   * @memberof InlineObject1
   */
  customerId?: number;
  /**
   *
   * @type {boolean}
   * @memberof InlineObject1
   */
  force?: boolean;
}
/**
 *
 * @export
 * @interface InlineObject10
 */
export interface InlineObject10 {
  /**
   *
   * @type {string}
   * @memberof InlineObject10
   */
  href?: string;
  /**
   *
   * @type {string}
   * @memberof InlineObject10
   */
  title?: string;
  /**
   *
   * @type {number}
   * @memberof InlineObject10
   */
  order?: number;
}
/**
 *
 * @export
 * @interface InlineObject11
 */
export interface InlineObject11 {
  /**
   *
   * @type {string}
   * @memberof InlineObject11
   */
  href?: string;
  /**
   *
   * @type {string}
   * @memberof InlineObject11
   */
  title?: string;
  /**
   *
   * @type {number}
   * @memberof InlineObject11
   */
  order?: number;
}
/**
 *
 * @export
 * @interface InlineObject12
 */
export interface InlineObject12 {
  /**
   *
   * @type {number}
   * @memberof InlineObject12
   */
  updatedAt?: number | null;
  /**
   *
   * @type {string}
   * @memberof InlineObject12
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof InlineObject12
   */
  name?: string;
  /**
   *
   * @type {number}
   * @memberof InlineObject12
   */
  deletedAt?: number | null;
  /**
   *
   * @type {string}
   * @memberof InlineObject12
   */
  description?: string | null;
  /**
   *
   * @type {number}
   * @memberof InlineObject12
   */
  avatarId?: number;
  /**
   *
   * @type {string}
   * @memberof InlineObject12
   */
  slug?: string;
}
/**
 *
 * @export
 * @interface InlineObject13
 */
export interface InlineObject13 {
  /**
   *
   * @type {string}
   * @memberof InlineObject13
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof InlineObject13
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof InlineObject13
   */
  description?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof InlineObject13
   */
  isAvatar?: boolean;
  /**
   *
   * @type {number}
   * @memberof InlineObject13
   */
  avatarId?: number;
  /**
   *
   * @type {string}
   * @memberof InlineObject13
   */
  slug?: string;
}
/**
 *
 * @export
 * @interface InlineObject14
 */
export interface InlineObject14 {
  /**
   *
   * @type {string}
   * @memberof InlineObject14
   */
  deviceToken?: string;
  /**
   *
   * @type {string}
   * @memberof InlineObject14
   */
  notificationId?: string;
}
/**
 *
 * @export
 * @interface InlineObject15
 */
export interface InlineObject15 {
  /**
   *
   * @type {number}
   * @memberof InlineObject15
   */
  userId?: number | null;
  /**
   *
   * @type {string}
   * @memberof InlineObject15
   */
  message?: string;
  /**
   *
   * @type {string}
   * @memberof InlineObject15
   */
  url?: string | null;
}
/**
 *
 * @export
 * @interface InlineObject16
 */
export interface InlineObject16 {
  /**
   *
   * @type {string}
   * @memberof InlineObject16
   */
  message?: string;
  /**
   *
   * @type {string}
   * @memberof InlineObject16
   */
  url?: string | null;
  /**
   *
   * @type {string}
   * @memberof InlineObject16
   */
  deviceToken?: string;
}
/**
 *
 * @export
 * @interface InlineObject17
 */
export interface InlineObject17 {
  /**
   *
   * @type {Array<CreatorsCreatorIdLinksOrderLinks>}
   * @memberof InlineObject17
   */
  posts?: Array<CreatorsCreatorIdLinksOrderLinks>;
}
/**
 *
 * @export
 * @interface InlineObject18
 */
export interface InlineObject18 {
  /**
   *
   * @type {object}
   * @memberof InlineObject18
   */
  content?: object | null;
  /**
   *
   * @type {number}
   * @memberof InlineObject18
   */
  order?: number | null;
  /**
   *
   * @type {string}
   * @memberof InlineObject18
   */
  type?: InlineObject18TypeEnum;
  /**
   *
   * @type {string}
   * @memberof InlineObject18
   */
  event?: InlineObject18EventEnum;
  /**
   *
   * @type {object}
   * @memberof InlineObject18
   */
  eventParams?: object | null;
  /**
   *
   * @type {number}
   * @memberof InlineObject18
   */
  publishAt?: number | null;
}

export const InlineObject18TypeEnum = {
  Onboarding: 'onboarding',
  Realtime: 'realtime',
  AfterEvent: 'afterEvent',
  Deferred: 'deferred',
} as const;

export type InlineObject18TypeEnum = typeof InlineObject18TypeEnum[keyof typeof InlineObject18TypeEnum];
export const InlineObject18EventEnum = {
  TripleMarkAsComplete: 'tripleMarkAsComplete',
} as const;

export type InlineObject18EventEnum = typeof InlineObject18EventEnum[keyof typeof InlineObject18EventEnum];

/**
 *
 * @export
 * @interface InlineObject19
 */
export interface InlineObject19 {
  /**
   *
   * @type {object}
   * @memberof InlineObject19
   */
  content?: object;
  /**
   *
   * @type {string}
   * @memberof InlineObject19
   */
  type?: InlineObject19TypeEnum;
  /**
   *
   * @type {string}
   * @memberof InlineObject19
   */
  event?: InlineObject19EventEnum;
  /**
   *
   * @type {object}
   * @memberof InlineObject19
   */
  eventParams?: object | null;
  /**
   *
   * @type {number}
   * @memberof InlineObject19
   */
  publishAt?: number | null;
}

export const InlineObject19TypeEnum = {
  Onboarding: 'onboarding',
  Realtime: 'realtime',
  AfterEvent: 'afterEvent',
  Deferred: 'deferred',
} as const;

export type InlineObject19TypeEnum = typeof InlineObject19TypeEnum[keyof typeof InlineObject19TypeEnum];
export const InlineObject19EventEnum = {
  TripleMarkAsComplete: 'tripleMarkAsComplete',
} as const;

export type InlineObject19EventEnum = typeof InlineObject19EventEnum[keyof typeof InlineObject19EventEnum];

/**
 *
 * @export
 * @interface InlineObject2
 */
export interface InlineObject2 {
  /**
   *
   * @type {Array<CategoriesClubsCategoryIdManualCreate>}
   * @memberof InlineObject2
   */
  create?: Array<CategoriesClubsCategoryIdManualCreate>;
  /**
   *
   * @type {Array<CategoriesClubsCategoryIdManualCreate>}
   * @memberof InlineObject2
   */
  update?: Array<CategoriesClubsCategoryIdManualCreate>;
  /**
   *
   * @type {Array<CategoriesClubsCategoryIdManualDelete>}
   * @memberof InlineObject2
   */
  delete?: Array<CategoriesClubsCategoryIdManualDelete>;
}
/**
 *
 * @export
 * @interface InlineObject20
 */
export interface InlineObject20 {
  /**
   *
   * @type {number}
   * @memberof InlineObject20
   */
  price?: number | null;
  /**
   *
   * @type {number}
   * @memberof InlineObject20
   */
  creatorPrice?: number | null;
  /**
   *
   * @type {string}
   * @memberof InlineObject20
   */
  priceModel?: InlineObject20PriceModelEnum;
  /**
   *
   * @type {object}
   * @memberof InlineObject20
   */
  priceConfig?: object | null;
  /**
   *
   * @type {object}
   * @memberof InlineObject20
   */
  marketingPriceConfig?: object | null;
}

export const InlineObject20PriceModelEnum = {
  Fixed: 'fixed',
  Auction: 'auction',
} as const;

export type InlineObject20PriceModelEnum =
  typeof InlineObject20PriceModelEnum[keyof typeof InlineObject20PriceModelEnum];

/**
 *
 * @export
 * @interface InlineObject21
 */
export interface InlineObject21 {
  /**
   *
   * @type {number}
   * @memberof InlineObject21
   */
  weight?: number;
}
/**
 *
 * @export
 * @interface InlineObject22
 */
export interface InlineObject22 {
  /**
   *
   * @type {string}
   * @memberof InlineObject22
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof InlineObject22
   */
  color?: string;
}
/**
 *
 * @export
 * @interface InlineObject23
 */
export interface InlineObject23 {
  /**
   *
   * @type {string}
   * @memberof InlineObject23
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof InlineObject23
   */
  color?: string;
}
/**
 *
 * @export
 * @interface InlineObject24
 */
export interface InlineObject24 {
  /**
   *
   * @type {number}
   * @memberof InlineObject24
   */
  spaceId?: number;
  /**
   *
   * @type {number}
   * @memberof InlineObject24
   */
  customerId?: number;
  /**
   *
   * @type {boolean}
   * @memberof InlineObject24
   */
  force?: boolean;
}
/**
 *
 * @export
 * @interface InlineObject25
 */
export interface InlineObject25 {
  /**
   *
   * @type {object}
   * @memberof InlineObject25
   */
  message?: object;
  /**
   *
   * @type {boolean}
   * @memberof InlineObject25
   */
  encode?: boolean;
}
/**
 *
 * @export
 * @interface InlineObject3
 */
export interface InlineObject3 {
  /**
   *
   * @type {string}
   * @memberof InlineObject3
   */
  title?: string | null;
  /**
   *
   * @type {number}
   * @memberof InlineObject3
   */
  order?: number | null;
  /**
   *
   * @type {object}
   * @memberof InlineObject3
   */
  config?: object | null;
  /**
   *
   * @type {boolean}
   * @memberof InlineObject3
   */
  isCompilation?: boolean | null;
  /**
   *
   * @type {number}
   * @memberof InlineObject3
   */
  coverFileId?: number | null;
  /**
   *
   * @type {string}
   * @memberof InlineObject3
   */
  size?: InlineObject3SizeEnum;
}

export const InlineObject3SizeEnum = {
  Small: 'small',
  Big: 'big',
} as const;

export type InlineObject3SizeEnum = typeof InlineObject3SizeEnum[keyof typeof InlineObject3SizeEnum];

/**
 *
 * @export
 * @interface InlineObject4
 */
export interface InlineObject4 {
  /**
   *
   * @type {string}
   * @memberof InlineObject4
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof InlineObject4
   */
  madeBy?: InlineObject4MadeByEnum;
  /**
   *
   * @type {number}
   * @memberof InlineObject4
   */
  order?: number;
  /**
   *
   * @type {object}
   * @memberof InlineObject4
   */
  config?: object | null;
  /**
   *
   * @type {boolean}
   * @memberof InlineObject4
   */
  isCompilation?: boolean;
  /**
   *
   * @type {number}
   * @memberof InlineObject4
   */
  coverFileId?: number | null;
  /**
   *
   * @type {string}
   * @memberof InlineObject4
   */
  size?: InlineObject4SizeEnum;
}

export const InlineObject4MadeByEnum = {
  Manual: 'manual',
  Popular: 'popular',
} as const;

export type InlineObject4MadeByEnum = typeof InlineObject4MadeByEnum[keyof typeof InlineObject4MadeByEnum];
export const InlineObject4SizeEnum = {
  Small: 'small',
  Big: 'big',
} as const;

export type InlineObject4SizeEnum = typeof InlineObject4SizeEnum[keyof typeof InlineObject4SizeEnum];

/**
 *
 * @export
 * @interface InlineObject5
 */
export interface InlineObject5 {
  /**
   *
   * @type {Array<CategoriesSpacesCategoryIdManualCreate>}
   * @memberof InlineObject5
   */
  create?: Array<CategoriesSpacesCategoryIdManualCreate> | null;
  /**
   *
   * @type {Array<CategoriesSpacesCategoryIdManualCreate>}
   * @memberof InlineObject5
   */
  update?: Array<CategoriesSpacesCategoryIdManualCreate>;
  /**
   *
   * @type {Array<CategoriesClubsCategoryIdManualDelete>}
   * @memberof InlineObject5
   */
  delete?: Array<CategoriesClubsCategoryIdManualDelete>;
}
/**
 *
 * @export
 * @interface InlineObject6
 */
export interface InlineObject6 {
  /**
   *
   * @type {string}
   * @memberof InlineObject6
   */
  title?: string | null;
  /**
   *
   * @type {number}
   * @memberof InlineObject6
   */
  order?: number | null;
  /**
   *
   * @type {object}
   * @memberof InlineObject6
   */
  config?: object | null;
  /**
   *
   * @type {boolean}
   * @memberof InlineObject6
   */
  isCompilation?: boolean | null;
  /**
   *
   * @type {number}
   * @memberof InlineObject6
   */
  coverFileId?: number | null;
  /**
   *
   * @type {string}
   * @memberof InlineObject6
   */
  size?: InlineObject6SizeEnum;
}

export const InlineObject6SizeEnum = {
  Small: 'small',
  Big: 'big',
} as const;

export type InlineObject6SizeEnum = typeof InlineObject6SizeEnum[keyof typeof InlineObject6SizeEnum];

/**
 *
 * @export
 * @interface InlineObject7
 */
export interface InlineObject7 {
  /**
   *
   * @type {string}
   * @memberof InlineObject7
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof InlineObject7
   */
  madeBy?: InlineObject7MadeByEnum;
  /**
   *
   * @type {number}
   * @memberof InlineObject7
   */
  order?: number;
  /**
   *
   * @type {object}
   * @memberof InlineObject7
   */
  config?: object | null;
  /**
   *
   * @type {boolean}
   * @memberof InlineObject7
   */
  isCompilation?: boolean;
  /**
   *
   * @type {number}
   * @memberof InlineObject7
   */
  coverFileId?: number | null;
  /**
   *
   * @type {string}
   * @memberof InlineObject7
   */
  size?: InlineObject7SizeEnum;
}

export const InlineObject7MadeByEnum = {
  Manual: 'manual',
  Popular: 'popular',
  All: 'all',
} as const;

export type InlineObject7MadeByEnum = typeof InlineObject7MadeByEnum[keyof typeof InlineObject7MadeByEnum];
export const InlineObject7SizeEnum = {
  Small: 'small',
  Big: 'big',
} as const;

export type InlineObject7SizeEnum = typeof InlineObject7SizeEnum[keyof typeof InlineObject7SizeEnum];

/**
 *
 * @export
 * @interface InlineObject8
 */
export interface InlineObject8 {
  /**
   *
   * @type {string}
   * @memberof InlineObject8
   */
  title?: string | null;
  /**
   *
   * @type {number}
   * @memberof InlineObject8
   */
  subscriptionPrice?: number | null;
}
/**
 *
 * @export
 * @interface InlineObject9
 */
export interface InlineObject9 {
  /**
   *
   * @type {Array<CreatorsCreatorIdLinksOrderLinks>}
   * @memberof InlineObject9
   */
  links?: Array<CreatorsCreatorIdLinksOrderLinks>;
}
/**
 *
 * @export
 * @interface InlineResponse200
 */
export interface InlineResponse200 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse200
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse200
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse200
   */
  name?: string;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse200
   */
  isAvatar?: boolean;
  /**
   *
   * @type {InlineResponse200Club}
   * @memberof InlineResponse200
   */
  club?: InlineResponse200Club | null;
  /**
   *
   * @type {InlineResponse200Avatar}
   * @memberof InlineResponse200
   */
  avatar?: InlineResponse200Avatar | null;
}
/**
 *
 * @export
 * @interface InlineResponse2001
 */
export interface InlineResponse2001 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2001
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2001
   */
  createdAt?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2001
   */
  deletedAt?: number | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2001
   */
  clubId?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2001
   */
  categoryId?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2001
   */
  order?: number | null;
  /**
   *
   * @type {CategoriesClubsCategoryIdManualClub}
   * @memberof InlineResponse2001
   */
  club?: CategoriesClubsCategoryIdManualClub | null;
}
/**
 *
 * @export
 * @interface InlineResponse20010
 */
export interface InlineResponse20010 {
  /**
   *
   * @type {string}
   * @memberof InlineResponse20010
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20010
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20010
   */
  description?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse20010
   */
  isAvatar?: boolean;
  /**
   *
   * @type {InlineResponse200Avatar}
   * @memberof InlineResponse20010
   */
  avatar?: InlineResponse200Avatar | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20010
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20010
   */
  created_at?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20010
   */
  updatedAt?: number | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20010
   */
  user?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20010
   */
  slug?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20010
   */
  userSlug?: string | null;
  /**
   *
   * @type {InlineResponse200Club}
   * @memberof InlineResponse20010
   */
  club?: InlineResponse200Club | null;
}
/**
 *
 * @export
 * @interface InlineResponse20011
 */
export interface InlineResponse20011 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse20011
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20011
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20011
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20011
   */
  description?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse20011
   */
  isAvatar?: boolean;
  /**
   *
   * @type {InlineResponse200Avatar}
   * @memberof InlineResponse20011
   */
  avatar?: InlineResponse200Avatar | null;
  /**
   *
   * @type {InlineResponse200Club}
   * @memberof InlineResponse20011
   */
  club?: InlineResponse200Club | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20011
   */
  slug?: string;
}
/**
 *
 * @export
 * @interface InlineResponse20012
 */
export interface InlineResponse20012 {
  /**
   *
   * @type {string}
   * @memberof InlineResponse20012
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20012
   */
  name?: string;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse20012
   */
  isAvatar?: boolean;
  /**
   *
   * @type {InlineResponse200Avatar}
   * @memberof InlineResponse20012
   */
  avatar?: InlineResponse200Avatar | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20012
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20012
   */
  created_at?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20012
   */
  updatedAt?: number | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20012
   */
  user?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20012
   */
  slug?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20012
   */
  userSlug?: string | null;
  /**
   *
   * @type {InlineResponse200Club}
   * @memberof InlineResponse20012
   */
  club?: InlineResponse200Club | null;
}
/**
 *
 * @export
 * @interface InlineResponse20013
 */
export interface InlineResponse20013 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse20013
   */
  id?: number;
  /**
   *
   * @type {ModerationChatsSpaceSpace}
   * @memberof InlineResponse20013
   */
  space?: ModerationChatsSpaceSpace | null;
}
/**
 *
 * @export
 * @interface InlineResponse20014
 */
export interface InlineResponse20014 {
  /**
   *
   * @type {string}
   * @memberof InlineResponse20014
   */
  successfull?: string;
}
/**
 *
 * @export
 * @interface InlineResponse20015
 */
export interface InlineResponse20015 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse20015
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20015
   */
  createdAt?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20015
   */
  updatedAt?: number | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20015
   */
  publishedAt?: number | null;
  /**
   *
   * @type {object}
   * @memberof InlineResponse20015
   */
  content?: object;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20015
   */
  order?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20015
   */
  type?: InlineResponse20015TypeEnum;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20015
   */
  event?: InlineResponse20015EventEnum;
  /**
   *
   * @type {object}
   * @memberof InlineResponse20015
   */
  eventParams?: object | null;
}

export const InlineResponse20015TypeEnum = {
  Onboarding: 'onboarding',
  Realtime: 'realtime',
  AfterEvent: 'afterEvent',
  Deferred: 'deferred',
} as const;

export type InlineResponse20015TypeEnum = typeof InlineResponse20015TypeEnum[keyof typeof InlineResponse20015TypeEnum];
export const InlineResponse20015EventEnum = {
  TripleMarkAsComplete: 'tripleMarkAsComplete',
} as const;

export type InlineResponse20015EventEnum =
  typeof InlineResponse20015EventEnum[keyof typeof InlineResponse20015EventEnum];

/**
 *
 * @export
 * @interface InlineResponse20016
 */
export interface InlineResponse20016 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse20016
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20016
   */
  createdAt?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20016
   */
  updatedAt?: number | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20016
   */
  publishAt?: number | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20016
   */
  publishedAt?: number | null;
  /**
   *
   * @type {object}
   * @memberof InlineResponse20016
   */
  content?: object;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20016
   */
  order?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20016
   */
  type?: InlineResponse20016TypeEnum;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20016
   */
  event?: InlineResponse20016EventEnum;
  /**
   *
   * @type {object}
   * @memberof InlineResponse20016
   */
  eventParams?: object | null;
}

export const InlineResponse20016TypeEnum = {
  Onboarding: 'onboarding',
  Realtime: 'realtime',
  AfterEvent: 'afterEvent',
  Deferred: 'deferred',
} as const;

export type InlineResponse20016TypeEnum = typeof InlineResponse20016TypeEnum[keyof typeof InlineResponse20016TypeEnum];
export const InlineResponse20016EventEnum = {
  TripleMarkAsComplete: 'tripleMarkAsComplete',
} as const;

export type InlineResponse20016EventEnum =
  typeof InlineResponse20016EventEnum[keyof typeof InlineResponse20016EventEnum];

/**
 *
 * @export
 * @interface InlineResponse20017
 */
export interface InlineResponse20017 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse20017
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20017
   */
  createdAt?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20017
   */
  updatedAt?: number | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20017
   */
  publishAt?: number | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20017
   */
  publishedAt?: number | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20017
   */
  sentAt?: number | null;
  /**
   *
   * @type {object}
   * @memberof InlineResponse20017
   */
  content?: object;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20017
   */
  order?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20017
   */
  type?: InlineResponse20017TypeEnum;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20017
   */
  event?: InlineResponse20017EventEnum;
  /**
   *
   * @type {object}
   * @memberof InlineResponse20017
   */
  eventParams?: object | null;
}

export const InlineResponse20017TypeEnum = {
  Onboarding: 'onboarding',
  Realtime: 'realtime',
  AfterEvent: 'afterEvent',
  Deferred: 'deferred',
} as const;

export type InlineResponse20017TypeEnum = typeof InlineResponse20017TypeEnum[keyof typeof InlineResponse20017TypeEnum];
export const InlineResponse20017EventEnum = {
  TripleMarkAsComplete: 'tripleMarkAsComplete',
} as const;

export type InlineResponse20017EventEnum =
  typeof InlineResponse20017EventEnum[keyof typeof InlineResponse20017EventEnum];

/**
 *
 * @export
 * @interface InlineResponse20018
 */
export interface InlineResponse20018 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse20018
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20018
   */
  price?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20018
   */
  creatorPrice?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20018
   */
  payment_type?: InlineResponse20018PaymentTypeEnum;
  /**
   *
   * @type {object}
   * @memberof InlineResponse20018
   */
  priceConfig?: object | null;
  /**
   *
   * @type {InlineResponse20018MarketingPriceConfig}
   * @memberof InlineResponse20018
   */
  marketingPriceConfig?: InlineResponse20018MarketingPriceConfig | null;
}

export const InlineResponse20018PaymentTypeEnum = {
  FixedPrice: 'fixed_price',
  FixedPriceSubscribersOnly: 'fixed_price_subscribers_only',
  SubscribersOnly: 'subscribers_only',
  Free: 'free',
  MonthlyPrice: 'monthly_price',
} as const;

export type InlineResponse20018PaymentTypeEnum =
  typeof InlineResponse20018PaymentTypeEnum[keyof typeof InlineResponse20018PaymentTypeEnum];

/**
 *
 * @export
 * @interface InlineResponse20018MarketingPriceConfig
 */
export interface InlineResponse20018MarketingPriceConfig {
  /**
   *
   * @type {number}
   * @memberof InlineResponse20018MarketingPriceConfig
   */
  previousPrice?: number | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20018MarketingPriceConfig
   */
  iosPrice?: number;
}
/**
 *
 * @export
 * @interface InlineResponse20019
 */
export interface InlineResponse20019 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse20019
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20019
   */
  price?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20019
   */
  creatorPrice?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20019
   */
  priceModel?: InlineResponse20019PriceModelEnum;
  /**
   *
   * @type {object}
   * @memberof InlineResponse20019
   */
  priceConfig?: object | null;
  /**
   *
   * @type {CreatorsCreatorIdChallengesMarketingPriceConfig}
   * @memberof InlineResponse20019
   */
  marketingPriceConfig?: CreatorsCreatorIdChallengesMarketingPriceConfig | null;
}

export const InlineResponse20019PriceModelEnum = {
  Fixed: 'fixed',
  Auction: 'auction',
} as const;

export type InlineResponse20019PriceModelEnum =
  typeof InlineResponse20019PriceModelEnum[keyof typeof InlineResponse20019PriceModelEnum];

/**
 *
 * @export
 * @interface InlineResponse2002
 */
export interface InlineResponse2002 {
  /**
   *
   * @type {string}
   * @memberof InlineResponse2002
   */
  created?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2002
   */
  deleted?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2002
   */
  updated?: string;
}
/**
 *
 * @export
 * @interface InlineResponse20020
 */
export interface InlineResponse20020 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse20020
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20020
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20020
   */
  type?: InlineResponse20020TypeEnum;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20020
   */
  status?: InlineResponse20020StatusEnum;
  /**
   *
   * @type {SpacesConfig}
   * @memberof InlineResponse20020
   */
  config?: SpacesConfig | null;
  /**
   *
   * @type {CreatorsCreatorIdChallengesMarketingPriceConfig}
   * @memberof InlineResponse20020
   */
  marketingPriceConfig?: CreatorsCreatorIdChallengesMarketingPriceConfig | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20020
   */
  stepsCount?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20020
   */
  startAt?: number | null;
  /**
   *
   * @type {SpacesCreator}
   * @memberof InlineResponse20020
   */
  creator?: SpacesCreator | null;
  /**
   *
   * @type {InlineResponse200Avatar}
   * @memberof InlineResponse20020
   */
  cover?: InlineResponse200Avatar | null;
  /**
   *
   * @type {Array<SpacesTags>}
   * @memberof InlineResponse20020
   */
  tags?: Array<SpacesTags>;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20020
   */
  slug?: string;
}

export const InlineResponse20020TypeEnum = {
  Post: 'post',
  Live: 'live',
  Challenge: 'challenge',
  Trailer: 'trailer',
  Channel: 'channel',
} as const;

export type InlineResponse20020TypeEnum = typeof InlineResponse20020TypeEnum[keyof typeof InlineResponse20020TypeEnum];
export const InlineResponse20020StatusEnum = {
  Draft: 'draft',
  Published: 'published',
} as const;

export type InlineResponse20020StatusEnum =
  typeof InlineResponse20020StatusEnum[keyof typeof InlineResponse20020StatusEnum];

/**
 *
 * @export
 * @interface InlineResponse20021
 */
export interface InlineResponse20021 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse20021
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20021
   */
  createdAt?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20021
   */
  deletedAt?: number | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20021
   */
  spaceId?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20021
   */
  tagId?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20021
   */
  weight?: number;
}
/**
 *
 * @export
 * @interface InlineResponse20022
 */
export interface InlineResponse20022 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse20022
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20022
   */
  createdAt?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20022
   */
  updatedAt?: number | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20022
   */
  deletedAt?: number | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20022
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20022
   */
  color?: string;
}
/**
 *
 * @export
 * @interface InlineResponse20023
 */
export interface InlineResponse20023 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse20023
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20023
   */
  created_at?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20023
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20023
   */
  name?: string;
  /**
   *
   * @type {InlineResponse200Avatar}
   * @memberof InlineResponse20023
   */
  avatar?: InlineResponse200Avatar | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20023
   */
  slug?: string;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20023
   */
  spent?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20023
   */
  purchasedCount?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20023
   */
  trialsCount?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20023
   */
  addedToHomeCount?: number;
}
/**
 *
 * @export
 * @interface InlineResponse2003
 */
export interface InlineResponse2003 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2003
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2003
   */
  createdAt?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2003
   */
  updatedAt?: number | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2003
   */
  deletedAt?: number | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2003
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2003
   */
  madeBy?: InlineResponse2003MadeByEnum;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2003
   */
  order?: number;
  /**
   *
   * @type {object}
   * @memberof InlineResponse2003
   */
  config?: object | null;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse2003
   */
  isCompilation?: boolean;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2003
   */
  coverFileId?: number | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2003
   */
  size?: InlineResponse2003SizeEnum;
  /**
   *
   * @type {InlineResponse200Avatar}
   * @memberof InlineResponse2003
   */
  cover?: InlineResponse200Avatar | null;
}

export const InlineResponse2003MadeByEnum = {
  Manual: 'manual',
  Popular: 'popular',
} as const;

export type InlineResponse2003MadeByEnum =
  typeof InlineResponse2003MadeByEnum[keyof typeof InlineResponse2003MadeByEnum];
export const InlineResponse2003SizeEnum = {
  Small: 'small',
  Big: 'big',
} as const;

export type InlineResponse2003SizeEnum = typeof InlineResponse2003SizeEnum[keyof typeof InlineResponse2003SizeEnum];

/**
 *
 * @export
 * @interface InlineResponse2004
 */
export interface InlineResponse2004 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2004
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2004
   */
  createdAt?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2004
   */
  deletedAt?: number | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2004
   */
  spaceId?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2004
   */
  categoryId?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2004
   */
  order?: number | null;
  /**
   *
   * @type {CategoriesSpacesCategoryIdManualSpace}
   * @memberof InlineResponse2004
   */
  space?: CategoriesSpacesCategoryIdManualSpace | null;
}
/**
 *
 * @export
 * @interface InlineResponse2005
 */
export interface InlineResponse2005 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2005
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2005
   */
  createdAt?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2005
   */
  updatedAt?: number | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2005
   */
  deletedAt?: number | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2005
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2005
   */
  madeBy?: InlineResponse2005MadeByEnum;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2005
   */
  order?: number;
  /**
   *
   * @type {object}
   * @memberof InlineResponse2005
   */
  config?: object | null;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse2005
   */
  isCompilation?: boolean;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2005
   */
  coverFileId?: number | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2005
   */
  size?: InlineResponse2005SizeEnum;
  /**
   *
   * @type {InlineResponse200Avatar}
   * @memberof InlineResponse2005
   */
  cover?: InlineResponse200Avatar | null;
}

export const InlineResponse2005MadeByEnum = {
  Manual: 'manual',
  Popular: 'popular',
  All: 'all',
} as const;

export type InlineResponse2005MadeByEnum =
  typeof InlineResponse2005MadeByEnum[keyof typeof InlineResponse2005MadeByEnum];
export const InlineResponse2005SizeEnum = {
  Small: 'small',
  Big: 'big',
} as const;

export type InlineResponse2005SizeEnum = typeof InlineResponse2005SizeEnum[keyof typeof InlineResponse2005SizeEnum];

/**
 *
 * @export
 * @interface InlineResponse2006
 */
export interface InlineResponse2006 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2006
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2006
   */
  owner?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2006
   */
  title?: string | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2006
   */
  subscriptionPrice?: number | null;
}
/**
 *
 * @export
 * @interface InlineResponse2007
 */
export interface InlineResponse2007 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2007
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2007
   */
  created_at?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2007
   */
  updated_at?: number | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2007
   */
  title?: string;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2007
   */
  price?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2007
   */
  type?: InlineResponse2007TypeEnum;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2007
   */
  status?: InlineResponse2007StatusEnum;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2007
   */
  payment_type?: InlineResponse2007PaymentTypeEnum;
  /**
   *
   * @type {object}
   * @memberof InlineResponse2007
   */
  meta?: object | null;
  /**
   *
   * @type {CreatorsCreatorIdChallengesConfig}
   * @memberof InlineResponse2007
   */
  config?: CreatorsCreatorIdChallengesConfig | null;
  /**
   *
   * @type {CreatorsCreatorIdChallengesMarketingPriceConfig}
   * @memberof InlineResponse2007
   */
  marketingPriceConfig?: CreatorsCreatorIdChallengesMarketingPriceConfig | null;
  /**
   *
   * @type {InlineResponse200Avatar}
   * @memberof InlineResponse2007
   */
  cover?: InlineResponse200Avatar | null;
}

export const InlineResponse2007TypeEnum = {
  Post: 'post',
  Live: 'live',
  Challenge: 'challenge',
  Trailer: 'trailer',
  Channel: 'channel',
} as const;

export type InlineResponse2007TypeEnum = typeof InlineResponse2007TypeEnum[keyof typeof InlineResponse2007TypeEnum];
export const InlineResponse2007StatusEnum = {
  Draft: 'draft',
  Published: 'published',
} as const;

export type InlineResponse2007StatusEnum =
  typeof InlineResponse2007StatusEnum[keyof typeof InlineResponse2007StatusEnum];
export const InlineResponse2007PaymentTypeEnum = {
  FixedPrice: 'fixed_price',
  FixedPriceSubscribersOnly: 'fixed_price_subscribers_only',
  SubscribersOnly: 'subscribers_only',
  Free: 'free',
  MonthlyPrice: 'monthly_price',
} as const;

export type InlineResponse2007PaymentTypeEnum =
  typeof InlineResponse2007PaymentTypeEnum[keyof typeof InlineResponse2007PaymentTypeEnum];

/**
 *
 * @export
 * @interface InlineResponse2008
 */
export interface InlineResponse2008 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2008
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2008
   */
  createdAt?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2008
   */
  updatedAt?: number | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2008
   */
  href?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2008
   */
  title?: string;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2008
   */
  order?: number;
}
/**
 *
 * @export
 * @interface InlineResponse2009
 */
export interface InlineResponse2009 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2009
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2009
   */
  createdAt?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2009
   */
  href?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2009
   */
  title?: string;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2009
   */
  order?: number;
}
/**
 *
 * @export
 * @interface InlineResponse200Avatar
 */
export interface InlineResponse200Avatar {
  /**
   *
   * @type {number}
   * @memberof InlineResponse200Avatar
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse200Avatar
   */
  url?: string;
}
/**
 *
 * @export
 * @interface InlineResponse200Club
 */
export interface InlineResponse200Club {
  /**
   *
   * @type {number}
   * @memberof InlineResponse200Club
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse200Club
   */
  title?: string | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse200Club
   */
  subscriptionPrice?: number | null;
}
/**
 *
 * @export
 * @interface ModerationChatsSpaceSpace
 */
export interface ModerationChatsSpaceSpace {
  /**
   *
   * @type {number}
   * @memberof ModerationChatsSpaceSpace
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof ModerationChatsSpaceSpace
   */
  title?: string;
  /**
   *
   * @type {ModerationChatsSpaceSpaceCreator}
   * @memberof ModerationChatsSpaceSpace
   */
  creator?: ModerationChatsSpaceSpaceCreator | null;
  /**
   *
   * @type {InlineResponse200Avatar}
   * @memberof ModerationChatsSpaceSpace
   */
  cover?: InlineResponse200Avatar | null;
}
/**
 *
 * @export
 * @interface ModerationChatsSpaceSpaceCreator
 */
export interface ModerationChatsSpaceSpaceCreator {
  /**
   *
   * @type {number}
   * @memberof ModerationChatsSpaceSpaceCreator
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof ModerationChatsSpaceSpaceCreator
   */
  name?: string;
}
/**
 *
 * @export
 * @interface SpacesConfig
 */
export interface SpacesConfig {
  /**
   *
   * @type {CreatorsCreatorIdChallengesConfigChallenge}
   * @memberof SpacesConfig
   */
  challenge?: CreatorsCreatorIdChallengesConfigChallenge | null;
  /**
   *
   * @type {SpacesConfigLive}
   * @memberof SpacesConfig
   */
  live?: SpacesConfigLive | null;
}
/**
 *
 * @export
 * @interface SpacesConfigLive
 */
export interface SpacesConfigLive {
  /**
   *
   * @type {number}
   * @memberof SpacesConfigLive
   */
  startAt?: number;
  /**
   *
   * @type {number}
   * @memberof SpacesConfigLive
   */
  duration?: number;
}
/**
 *
 * @export
 * @interface SpacesCreator
 */
export interface SpacesCreator {
  /**
   *
   * @type {number}
   * @memberof SpacesCreator
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof SpacesCreator
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof SpacesCreator
   */
  description?: string | null;
  /**
   *
   * @type {InlineResponse200Avatar}
   * @memberof SpacesCreator
   */
  avatar?: InlineResponse200Avatar | null;
}
/**
 *
 * @export
 * @interface SpacesTags
 */
export interface SpacesTags {
  /**
   *
   * @type {number}
   * @memberof SpacesTags
   */
  weight?: number;
  /**
   *
   * @type {number}
   * @memberof SpacesTags
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof SpacesTags
   */
  name?: string;
}

/**
 * AvatarsApi - axios parameter creator
 * @export
 */
export const AvatarsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} avatarId
     * @param {InlineObject} [inlineObject]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    avatarsAvatarIdReplacePost: async (
      avatarId: number,
      inlineObject?: InlineObject,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'avatarId' is not null or undefined
      assertParamExists('avatarsAvatarIdReplacePost', 'avatarId', avatarId);
      const localVarPath = `/avatars/{avatarId}/replace`.replace(
        `{${'avatarId'}}`,
        encodeURIComponent(String(avatarId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(inlineObject, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * AvatarsApi - functional programming interface
 * @export
 */
export const AvatarsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AvatarsApiAxiosParamCreator(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} avatarId
     * @param {InlineObject} [inlineObject]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async avatarsAvatarIdReplacePost(
      avatarId: number,
      inlineObject?: InlineObject,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.avatarsAvatarIdReplacePost(
        avatarId,
        inlineObject,
        options,
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * AvatarsApi - factory interface
 * @export
 */
export const AvatarsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = AvatarsApiFp(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} avatarId
     * @param {InlineObject} [inlineObject]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    avatarsAvatarIdReplacePost(
      avatarId: number,
      inlineObject?: InlineObject,
      options?: any,
    ): AxiosPromise<InlineResponse200> {
      return localVarFp
        .avatarsAvatarIdReplacePost(avatarId, inlineObject, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * AvatarsApi - object-oriented interface
 * @export
 * @class AvatarsApi
 * @extends {BaseAPI}
 */
export class AvatarsApi extends BaseAPI {
  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} avatarId
   * @param {InlineObject} [inlineObject]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AvatarsApi
   */
  public avatarsAvatarIdReplacePost(avatarId: number, inlineObject?: InlineObject, options?: AxiosRequestConfig) {
    return AvatarsApiFp(this.configuration)
      .avatarsAvatarIdReplacePost(avatarId, inlineObject, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * BuyForFreeApi - axios parameter creator
 * @export
 */
export const BuyForFreeApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject1} [inlineObject1]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    buyForFreePost: async (inlineObject1?: InlineObject1, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/buyForFree`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(inlineObject1, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * BuyForFreeApi - functional programming interface
 * @export
 */
export const BuyForFreeApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = BuyForFreeApiAxiosParamCreator(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject1} [inlineObject1]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async buyForFreePost(
      inlineObject1?: InlineObject1,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.buyForFreePost(inlineObject1, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * BuyForFreeApi - factory interface
 * @export
 */
export const BuyForFreeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = BuyForFreeApiFp(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject1} [inlineObject1]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    buyForFreePost(inlineObject1?: InlineObject1, options?: any): AxiosPromise<object> {
      return localVarFp.buyForFreePost(inlineObject1, options).then(request => request(axios, basePath));
    },
  };
};

/**
 * BuyForFreeApi - object-oriented interface
 * @export
 * @class BuyForFreeApi
 * @extends {BaseAPI}
 */
export class BuyForFreeApi extends BaseAPI {
  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {InlineObject1} [inlineObject1]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BuyForFreeApi
   */
  public buyForFreePost(inlineObject1?: InlineObject1, options?: AxiosRequestConfig) {
    return BuyForFreeApiFp(this.configuration)
      .buyForFreePost(inlineObject1, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * CategoriesApi - axios parameter creator
 * @export
 */
export const CategoriesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} categoryId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    categoriesClubsCategoryIdDelete: async (
      categoryId: number,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'categoryId' is not null or undefined
      assertParamExists('categoriesClubsCategoryIdDelete', 'categoryId', categoryId);
      const localVarPath = `/categories/clubs/{categoryId}`.replace(
        `{${'categoryId'}}`,
        encodeURIComponent(String(categoryId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} categoryId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    categoriesClubsCategoryIdGet: async (
      categoryId: number,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'categoryId' is not null or undefined
      assertParamExists('categoriesClubsCategoryIdGet', 'categoryId', categoryId);
      const localVarPath = `/categories/clubs/{categoryId}`.replace(
        `{${'categoryId'}}`,
        encodeURIComponent(String(categoryId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} categoryId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    categoriesClubsCategoryIdManualGet: async (
      categoryId: number,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'categoryId' is not null or undefined
      assertParamExists('categoriesClubsCategoryIdManualGet', 'categoryId', categoryId);
      const localVarPath = `/categories/clubs/{categoryId}/manual`.replace(
        `{${'categoryId'}}`,
        encodeURIComponent(String(categoryId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} categoryId
     * @param {InlineObject2} [inlineObject2]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    categoriesClubsCategoryIdManualPatch: async (
      categoryId: number,
      inlineObject2?: InlineObject2,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'categoryId' is not null or undefined
      assertParamExists('categoriesClubsCategoryIdManualPatch', 'categoryId', categoryId);
      const localVarPath = `/categories/clubs/{categoryId}/manual`.replace(
        `{${'categoryId'}}`,
        encodeURIComponent(String(categoryId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(inlineObject2, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} categoryId
     * @param {InlineObject3} [inlineObject3]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    categoriesClubsCategoryIdPatch: async (
      categoryId: number,
      inlineObject3?: InlineObject3,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'categoryId' is not null or undefined
      assertParamExists('categoriesClubsCategoryIdPatch', 'categoryId', categoryId);
      const localVarPath = `/categories/clubs/{categoryId}`.replace(
        `{${'categoryId'}}`,
        encodeURIComponent(String(categoryId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(inlineObject3, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    categoriesClubsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/categories/clubs`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject4} [inlineObject4]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    categoriesClubsPost: async (
      inlineObject4?: InlineObject4,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/categories/clubs`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(inlineObject4, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} categoryId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    categoriesSpacesCategoryIdDelete: async (
      categoryId: number,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'categoryId' is not null or undefined
      assertParamExists('categoriesSpacesCategoryIdDelete', 'categoryId', categoryId);
      const localVarPath = `/categories/spaces/{categoryId}`.replace(
        `{${'categoryId'}}`,
        encodeURIComponent(String(categoryId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} categoryId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    categoriesSpacesCategoryIdGet: async (
      categoryId: number,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'categoryId' is not null or undefined
      assertParamExists('categoriesSpacesCategoryIdGet', 'categoryId', categoryId);
      const localVarPath = `/categories/spaces/{categoryId}`.replace(
        `{${'categoryId'}}`,
        encodeURIComponent(String(categoryId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} categoryId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    categoriesSpacesCategoryIdManualGet: async (
      categoryId: number,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'categoryId' is not null or undefined
      assertParamExists('categoriesSpacesCategoryIdManualGet', 'categoryId', categoryId);
      const localVarPath = `/categories/spaces/{categoryId}/manual`.replace(
        `{${'categoryId'}}`,
        encodeURIComponent(String(categoryId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} categoryId
     * @param {InlineObject5} [inlineObject5]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    categoriesSpacesCategoryIdManualPatch: async (
      categoryId: number,
      inlineObject5?: InlineObject5,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'categoryId' is not null or undefined
      assertParamExists('categoriesSpacesCategoryIdManualPatch', 'categoryId', categoryId);
      const localVarPath = `/categories/spaces/{categoryId}/manual`.replace(
        `{${'categoryId'}}`,
        encodeURIComponent(String(categoryId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(inlineObject5, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} categoryId
     * @param {InlineObject6} [inlineObject6]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    categoriesSpacesCategoryIdPatch: async (
      categoryId: number,
      inlineObject6?: InlineObject6,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'categoryId' is not null or undefined
      assertParamExists('categoriesSpacesCategoryIdPatch', 'categoryId', categoryId);
      const localVarPath = `/categories/spaces/{categoryId}`.replace(
        `{${'categoryId'}}`,
        encodeURIComponent(String(categoryId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(inlineObject6, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    categoriesSpacesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/categories/spaces`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject7} [inlineObject7]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    categoriesSpacesPost: async (
      inlineObject7?: InlineObject7,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/categories/spaces`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(inlineObject7, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * CategoriesApi - functional programming interface
 * @export
 */
export const CategoriesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = CategoriesApiAxiosParamCreator(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} categoryId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async categoriesClubsCategoryIdDelete(
      categoryId: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.categoriesClubsCategoryIdDelete(categoryId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} categoryId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async categoriesClubsCategoryIdGet(
      categoryId: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2003>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.categoriesClubsCategoryIdGet(categoryId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} categoryId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async categoriesClubsCategoryIdManualGet(
      categoryId: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InlineResponse2001>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.categoriesClubsCategoryIdManualGet(categoryId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} categoryId
     * @param {InlineObject2} [inlineObject2]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async categoriesClubsCategoryIdManualPatch(
      categoryId: number,
      inlineObject2?: InlineObject2,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2002>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.categoriesClubsCategoryIdManualPatch(
        categoryId,
        inlineObject2,
        options,
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} categoryId
     * @param {InlineObject3} [inlineObject3]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async categoriesClubsCategoryIdPatch(
      categoryId: number,
      inlineObject3?: InlineObject3,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2003>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.categoriesClubsCategoryIdPatch(
        categoryId,
        inlineObject3,
        options,
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async categoriesClubsGet(
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InlineResponse2003>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.categoriesClubsGet(options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject4} [inlineObject4]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async categoriesClubsPost(
      inlineObject4?: InlineObject4,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2003>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.categoriesClubsPost(inlineObject4, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} categoryId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async categoriesSpacesCategoryIdDelete(
      categoryId: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.categoriesSpacesCategoryIdDelete(categoryId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} categoryId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async categoriesSpacesCategoryIdGet(
      categoryId: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2005>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.categoriesSpacesCategoryIdGet(categoryId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} categoryId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async categoriesSpacesCategoryIdManualGet(
      categoryId: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InlineResponse2004>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.categoriesSpacesCategoryIdManualGet(
        categoryId,
        options,
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} categoryId
     * @param {InlineObject5} [inlineObject5]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async categoriesSpacesCategoryIdManualPatch(
      categoryId: number,
      inlineObject5?: InlineObject5,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2002>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.categoriesSpacesCategoryIdManualPatch(
        categoryId,
        inlineObject5,
        options,
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} categoryId
     * @param {InlineObject6} [inlineObject6]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async categoriesSpacesCategoryIdPatch(
      categoryId: number,
      inlineObject6?: InlineObject6,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2005>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.categoriesSpacesCategoryIdPatch(
        categoryId,
        inlineObject6,
        options,
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async categoriesSpacesGet(
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InlineResponse2005>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.categoriesSpacesGet(options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject7} [inlineObject7]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async categoriesSpacesPost(
      inlineObject7?: InlineObject7,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2005>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.categoriesSpacesPost(inlineObject7, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * CategoriesApi - factory interface
 * @export
 */
export const CategoriesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = CategoriesApiFp(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} categoryId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    categoriesClubsCategoryIdDelete(categoryId: number, options?: any): AxiosPromise<object> {
      return localVarFp.categoriesClubsCategoryIdDelete(categoryId, options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} categoryId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    categoriesClubsCategoryIdGet(categoryId: number, options?: any): AxiosPromise<InlineResponse2003> {
      return localVarFp.categoriesClubsCategoryIdGet(categoryId, options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} categoryId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    categoriesClubsCategoryIdManualGet(categoryId: number, options?: any): AxiosPromise<Array<InlineResponse2001>> {
      return localVarFp
        .categoriesClubsCategoryIdManualGet(categoryId, options)
        .then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} categoryId
     * @param {InlineObject2} [inlineObject2]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    categoriesClubsCategoryIdManualPatch(
      categoryId: number,
      inlineObject2?: InlineObject2,
      options?: any,
    ): AxiosPromise<InlineResponse2002> {
      return localVarFp
        .categoriesClubsCategoryIdManualPatch(categoryId, inlineObject2, options)
        .then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} categoryId
     * @param {InlineObject3} [inlineObject3]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    categoriesClubsCategoryIdPatch(
      categoryId: number,
      inlineObject3?: InlineObject3,
      options?: any,
    ): AxiosPromise<InlineResponse2003> {
      return localVarFp
        .categoriesClubsCategoryIdPatch(categoryId, inlineObject3, options)
        .then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    categoriesClubsGet(options?: any): AxiosPromise<Array<InlineResponse2003>> {
      return localVarFp.categoriesClubsGet(options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject4} [inlineObject4]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    categoriesClubsPost(inlineObject4?: InlineObject4, options?: any): AxiosPromise<InlineResponse2003> {
      return localVarFp.categoriesClubsPost(inlineObject4, options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} categoryId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    categoriesSpacesCategoryIdDelete(categoryId: number, options?: any): AxiosPromise<object> {
      return localVarFp.categoriesSpacesCategoryIdDelete(categoryId, options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} categoryId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    categoriesSpacesCategoryIdGet(categoryId: number, options?: any): AxiosPromise<InlineResponse2005> {
      return localVarFp.categoriesSpacesCategoryIdGet(categoryId, options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} categoryId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    categoriesSpacesCategoryIdManualGet(categoryId: number, options?: any): AxiosPromise<Array<InlineResponse2004>> {
      return localVarFp
        .categoriesSpacesCategoryIdManualGet(categoryId, options)
        .then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} categoryId
     * @param {InlineObject5} [inlineObject5]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    categoriesSpacesCategoryIdManualPatch(
      categoryId: number,
      inlineObject5?: InlineObject5,
      options?: any,
    ): AxiosPromise<InlineResponse2002> {
      return localVarFp
        .categoriesSpacesCategoryIdManualPatch(categoryId, inlineObject5, options)
        .then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} categoryId
     * @param {InlineObject6} [inlineObject6]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    categoriesSpacesCategoryIdPatch(
      categoryId: number,
      inlineObject6?: InlineObject6,
      options?: any,
    ): AxiosPromise<InlineResponse2005> {
      return localVarFp
        .categoriesSpacesCategoryIdPatch(categoryId, inlineObject6, options)
        .then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    categoriesSpacesGet(options?: any): AxiosPromise<Array<InlineResponse2005>> {
      return localVarFp.categoriesSpacesGet(options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject7} [inlineObject7]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    categoriesSpacesPost(inlineObject7?: InlineObject7, options?: any): AxiosPromise<InlineResponse2005> {
      return localVarFp.categoriesSpacesPost(inlineObject7, options).then(request => request(axios, basePath));
    },
  };
};

/**
 * CategoriesApi - object-oriented interface
 * @export
 * @class CategoriesApi
 * @extends {BaseAPI}
 */
export class CategoriesApi extends BaseAPI {
  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} categoryId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CategoriesApi
   */
  public categoriesClubsCategoryIdDelete(categoryId: number, options?: AxiosRequestConfig) {
    return CategoriesApiFp(this.configuration)
      .categoriesClubsCategoryIdDelete(categoryId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} categoryId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CategoriesApi
   */
  public categoriesClubsCategoryIdGet(categoryId: number, options?: AxiosRequestConfig) {
    return CategoriesApiFp(this.configuration)
      .categoriesClubsCategoryIdGet(categoryId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} categoryId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CategoriesApi
   */
  public categoriesClubsCategoryIdManualGet(categoryId: number, options?: AxiosRequestConfig) {
    return CategoriesApiFp(this.configuration)
      .categoriesClubsCategoryIdManualGet(categoryId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} categoryId
   * @param {InlineObject2} [inlineObject2]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CategoriesApi
   */
  public categoriesClubsCategoryIdManualPatch(
    categoryId: number,
    inlineObject2?: InlineObject2,
    options?: AxiosRequestConfig,
  ) {
    return CategoriesApiFp(this.configuration)
      .categoriesClubsCategoryIdManualPatch(categoryId, inlineObject2, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} categoryId
   * @param {InlineObject3} [inlineObject3]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CategoriesApi
   */
  public categoriesClubsCategoryIdPatch(
    categoryId: number,
    inlineObject3?: InlineObject3,
    options?: AxiosRequestConfig,
  ) {
    return CategoriesApiFp(this.configuration)
      .categoriesClubsCategoryIdPatch(categoryId, inlineObject3, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CategoriesApi
   */
  public categoriesClubsGet(options?: AxiosRequestConfig) {
    return CategoriesApiFp(this.configuration)
      .categoriesClubsGet(options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {InlineObject4} [inlineObject4]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CategoriesApi
   */
  public categoriesClubsPost(inlineObject4?: InlineObject4, options?: AxiosRequestConfig) {
    return CategoriesApiFp(this.configuration)
      .categoriesClubsPost(inlineObject4, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} categoryId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CategoriesApi
   */
  public categoriesSpacesCategoryIdDelete(categoryId: number, options?: AxiosRequestConfig) {
    return CategoriesApiFp(this.configuration)
      .categoriesSpacesCategoryIdDelete(categoryId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} categoryId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CategoriesApi
   */
  public categoriesSpacesCategoryIdGet(categoryId: number, options?: AxiosRequestConfig) {
    return CategoriesApiFp(this.configuration)
      .categoriesSpacesCategoryIdGet(categoryId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} categoryId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CategoriesApi
   */
  public categoriesSpacesCategoryIdManualGet(categoryId: number, options?: AxiosRequestConfig) {
    return CategoriesApiFp(this.configuration)
      .categoriesSpacesCategoryIdManualGet(categoryId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} categoryId
   * @param {InlineObject5} [inlineObject5]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CategoriesApi
   */
  public categoriesSpacesCategoryIdManualPatch(
    categoryId: number,
    inlineObject5?: InlineObject5,
    options?: AxiosRequestConfig,
  ) {
    return CategoriesApiFp(this.configuration)
      .categoriesSpacesCategoryIdManualPatch(categoryId, inlineObject5, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} categoryId
   * @param {InlineObject6} [inlineObject6]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CategoriesApi
   */
  public categoriesSpacesCategoryIdPatch(
    categoryId: number,
    inlineObject6?: InlineObject6,
    options?: AxiosRequestConfig,
  ) {
    return CategoriesApiFp(this.configuration)
      .categoriesSpacesCategoryIdPatch(categoryId, inlineObject6, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CategoriesApi
   */
  public categoriesSpacesGet(options?: AxiosRequestConfig) {
    return CategoriesApiFp(this.configuration)
      .categoriesSpacesGet(options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {InlineObject7} [inlineObject7]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CategoriesApi
   */
  public categoriesSpacesPost(inlineObject7?: InlineObject7, options?: AxiosRequestConfig) {
    return CategoriesApiFp(this.configuration)
      .categoriesSpacesPost(inlineObject7, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * Class100msApi - axios parameter creator
 * @export
 */
export const Class100msApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * <br /><br /> <b>Authentication:</b> not required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    _100msTokenGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/100ms/token`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * Class100msApi - functional programming interface
 * @export
 */
export const Class100msApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = Class100msApiAxiosParamCreator(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> not required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async _100msTokenGet(
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator._100msTokenGet(options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * Class100msApi - factory interface
 * @export
 */
export const Class100msApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = Class100msApiFp(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> not required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    _100msTokenGet(options?: any): AxiosPromise<object> {
      return localVarFp._100msTokenGet(options).then(request => request(axios, basePath));
    },
  };
};

/**
 * Class100msApi - object-oriented interface
 * @export
 * @class Class100msApi
 * @extends {BaseAPI}
 */
export class Class100msApi extends BaseAPI {
  /**
   * <br /><br /> <b>Authentication:</b> not required
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof Class100msApi
   */
  public _100msTokenGet(options?: AxiosRequestConfig) {
    return Class100msApiFp(this.configuration)
      ._100msTokenGet(options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * ClubsApi - axios parameter creator
 * @export
 */
export const ClubsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} clubId
     * @param {InlineObject8} [inlineObject8]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clubsClubIdPost: async (
      clubId: number,
      inlineObject8?: InlineObject8,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'clubId' is not null or undefined
      assertParamExists('clubsClubIdPost', 'clubId', clubId);
      const localVarPath = `/clubs/{clubId}`.replace(`{${'clubId'}}`, encodeURIComponent(String(clubId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(inlineObject8, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ClubsApi - functional programming interface
 * @export
 */
export const ClubsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ClubsApiAxiosParamCreator(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} clubId
     * @param {InlineObject8} [inlineObject8]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clubsClubIdPost(
      clubId: number,
      inlineObject8?: InlineObject8,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2006>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.clubsClubIdPost(clubId, inlineObject8, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * ClubsApi - factory interface
 * @export
 */
export const ClubsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = ClubsApiFp(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} clubId
     * @param {InlineObject8} [inlineObject8]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clubsClubIdPost(clubId: number, inlineObject8?: InlineObject8, options?: any): AxiosPromise<InlineResponse2006> {
      return localVarFp.clubsClubIdPost(clubId, inlineObject8, options).then(request => request(axios, basePath));
    },
  };
};

/**
 * ClubsApi - object-oriented interface
 * @export
 * @class ClubsApi
 * @extends {BaseAPI}
 */
export class ClubsApi extends BaseAPI {
  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} clubId
   * @param {InlineObject8} [inlineObject8]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClubsApi
   */
  public clubsClubIdPost(clubId: number, inlineObject8?: InlineObject8, options?: AxiosRequestConfig) {
    return ClubsApiFp(this.configuration)
      .clubsClubIdPost(clubId, inlineObject8, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * CreatorsApi - axios parameter creator
 * @export
 */
export const CreatorsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} creatorId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    creatorsCreatorIdChallengesGet: async (
      creatorId: number,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'creatorId' is not null or undefined
      assertParamExists('creatorsCreatorIdChallengesGet', 'creatorId', creatorId);
      const localVarPath = `/creators/{creatorId}/challenges`.replace(
        `{${'creatorId'}}`,
        encodeURIComponent(String(creatorId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} creatorId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    creatorsCreatorIdLinksGet: async (creatorId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'creatorId' is not null or undefined
      assertParamExists('creatorsCreatorIdLinksGet', 'creatorId', creatorId);
      const localVarPath = `/creators/{creatorId}/links`.replace(
        `{${'creatorId'}}`,
        encodeURIComponent(String(creatorId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} linkId
     * @param {number} creatorId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    creatorsCreatorIdLinksLinkIdDelete: async (
      linkId: number,
      creatorId: number,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'linkId' is not null or undefined
      assertParamExists('creatorsCreatorIdLinksLinkIdDelete', 'linkId', linkId);
      // verify required parameter 'creatorId' is not null or undefined
      assertParamExists('creatorsCreatorIdLinksLinkIdDelete', 'creatorId', creatorId);
      const localVarPath = `/creators/{creatorId}/links/{linkId}`
        .replace(`{${'linkId'}}`, encodeURIComponent(String(linkId)))
        .replace(`{${'creatorId'}}`, encodeURIComponent(String(creatorId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} linkId
     * @param {number} creatorId
     * @param {InlineObject10} [inlineObject10]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    creatorsCreatorIdLinksLinkIdPost: async (
      linkId: number,
      creatorId: number,
      inlineObject10?: InlineObject10,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'linkId' is not null or undefined
      assertParamExists('creatorsCreatorIdLinksLinkIdPost', 'linkId', linkId);
      // verify required parameter 'creatorId' is not null or undefined
      assertParamExists('creatorsCreatorIdLinksLinkIdPost', 'creatorId', creatorId);
      const localVarPath = `/creators/{creatorId}/links/{linkId}`
        .replace(`{${'linkId'}}`, encodeURIComponent(String(linkId)))
        .replace(`{${'creatorId'}}`, encodeURIComponent(String(creatorId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(inlineObject10, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} creatorId
     * @param {InlineObject9} [inlineObject9]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    creatorsCreatorIdLinksOrderPatch: async (
      creatorId: number,
      inlineObject9?: InlineObject9,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'creatorId' is not null or undefined
      assertParamExists('creatorsCreatorIdLinksOrderPatch', 'creatorId', creatorId);
      const localVarPath = `/creators/{creatorId}/links/order`.replace(
        `{${'creatorId'}}`,
        encodeURIComponent(String(creatorId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(inlineObject9, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} creatorId
     * @param {InlineObject11} [inlineObject11]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    creatorsCreatorIdLinksPost: async (
      creatorId: number,
      inlineObject11?: InlineObject11,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'creatorId' is not null or undefined
      assertParamExists('creatorsCreatorIdLinksPost', 'creatorId', creatorId);
      const localVarPath = `/creators/{creatorId}/links`.replace(
        `{${'creatorId'}}`,
        encodeURIComponent(String(creatorId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(inlineObject11, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} creatorId
     * @param {InlineObject12} [inlineObject12]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    creatorsCreatorIdPatch: async (
      creatorId: number,
      inlineObject12?: InlineObject12,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'creatorId' is not null or undefined
      assertParamExists('creatorsCreatorIdPatch', 'creatorId', creatorId);
      const localVarPath = `/creators/{creatorId}`.replace(`{${'creatorId'}}`, encodeURIComponent(String(creatorId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(inlineObject12, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    creatorsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/creators`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject13} [inlineObject13]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    creatorsPost: async (inlineObject13?: InlineObject13, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/creators`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(inlineObject13, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * CreatorsApi - functional programming interface
 * @export
 */
export const CreatorsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = CreatorsApiAxiosParamCreator(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} creatorId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async creatorsCreatorIdChallengesGet(
      creatorId: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InlineResponse2007>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.creatorsCreatorIdChallengesGet(creatorId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} creatorId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async creatorsCreatorIdLinksGet(
      creatorId: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InlineResponse2008>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.creatorsCreatorIdLinksGet(creatorId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} linkId
     * @param {number} creatorId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async creatorsCreatorIdLinksLinkIdDelete(
      linkId: number,
      creatorId: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.creatorsCreatorIdLinksLinkIdDelete(
        linkId,
        creatorId,
        options,
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} linkId
     * @param {number} creatorId
     * @param {InlineObject10} [inlineObject10]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async creatorsCreatorIdLinksLinkIdPost(
      linkId: number,
      creatorId: number,
      inlineObject10?: InlineObject10,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2008>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.creatorsCreatorIdLinksLinkIdPost(
        linkId,
        creatorId,
        inlineObject10,
        options,
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} creatorId
     * @param {InlineObject9} [inlineObject9]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async creatorsCreatorIdLinksOrderPatch(
      creatorId: number,
      inlineObject9?: InlineObject9,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.creatorsCreatorIdLinksOrderPatch(
        creatorId,
        inlineObject9,
        options,
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} creatorId
     * @param {InlineObject11} [inlineObject11]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async creatorsCreatorIdLinksPost(
      creatorId: number,
      inlineObject11?: InlineObject11,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2009>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.creatorsCreatorIdLinksPost(
        creatorId,
        inlineObject11,
        options,
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} creatorId
     * @param {InlineObject12} [inlineObject12]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async creatorsCreatorIdPatch(
      creatorId: number,
      inlineObject12?: InlineObject12,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20010>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.creatorsCreatorIdPatch(
        creatorId,
        inlineObject12,
        options,
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async creatorsGet(
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InlineResponse20011>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.creatorsGet(options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject13} [inlineObject13]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async creatorsPost(
      inlineObject13?: InlineObject13,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20012>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.creatorsPost(inlineObject13, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * CreatorsApi - factory interface
 * @export
 */
export const CreatorsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = CreatorsApiFp(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} creatorId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    creatorsCreatorIdChallengesGet(creatorId: number, options?: any): AxiosPromise<Array<InlineResponse2007>> {
      return localVarFp.creatorsCreatorIdChallengesGet(creatorId, options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} creatorId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    creatorsCreatorIdLinksGet(creatorId: number, options?: any): AxiosPromise<Array<InlineResponse2008>> {
      return localVarFp.creatorsCreatorIdLinksGet(creatorId, options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} linkId
     * @param {number} creatorId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    creatorsCreatorIdLinksLinkIdDelete(linkId: number, creatorId: number, options?: any): AxiosPromise<object> {
      return localVarFp
        .creatorsCreatorIdLinksLinkIdDelete(linkId, creatorId, options)
        .then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} linkId
     * @param {number} creatorId
     * @param {InlineObject10} [inlineObject10]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    creatorsCreatorIdLinksLinkIdPost(
      linkId: number,
      creatorId: number,
      inlineObject10?: InlineObject10,
      options?: any,
    ): AxiosPromise<InlineResponse2008> {
      return localVarFp
        .creatorsCreatorIdLinksLinkIdPost(linkId, creatorId, inlineObject10, options)
        .then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} creatorId
     * @param {InlineObject9} [inlineObject9]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    creatorsCreatorIdLinksOrderPatch(
      creatorId: number,
      inlineObject9?: InlineObject9,
      options?: any,
    ): AxiosPromise<object> {
      return localVarFp
        .creatorsCreatorIdLinksOrderPatch(creatorId, inlineObject9, options)
        .then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} creatorId
     * @param {InlineObject11} [inlineObject11]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    creatorsCreatorIdLinksPost(
      creatorId: number,
      inlineObject11?: InlineObject11,
      options?: any,
    ): AxiosPromise<InlineResponse2009> {
      return localVarFp
        .creatorsCreatorIdLinksPost(creatorId, inlineObject11, options)
        .then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} creatorId
     * @param {InlineObject12} [inlineObject12]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    creatorsCreatorIdPatch(
      creatorId: number,
      inlineObject12?: InlineObject12,
      options?: any,
    ): AxiosPromise<InlineResponse20010> {
      return localVarFp
        .creatorsCreatorIdPatch(creatorId, inlineObject12, options)
        .then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    creatorsGet(options?: any): AxiosPromise<Array<InlineResponse20011>> {
      return localVarFp.creatorsGet(options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject13} [inlineObject13]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    creatorsPost(inlineObject13?: InlineObject13, options?: any): AxiosPromise<InlineResponse20012> {
      return localVarFp.creatorsPost(inlineObject13, options).then(request => request(axios, basePath));
    },
  };
};

/**
 * CreatorsApi - object-oriented interface
 * @export
 * @class CreatorsApi
 * @extends {BaseAPI}
 */
export class CreatorsApi extends BaseAPI {
  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} creatorId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CreatorsApi
   */
  public creatorsCreatorIdChallengesGet(creatorId: number, options?: AxiosRequestConfig) {
    return CreatorsApiFp(this.configuration)
      .creatorsCreatorIdChallengesGet(creatorId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} creatorId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CreatorsApi
   */
  public creatorsCreatorIdLinksGet(creatorId: number, options?: AxiosRequestConfig) {
    return CreatorsApiFp(this.configuration)
      .creatorsCreatorIdLinksGet(creatorId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} linkId
   * @param {number} creatorId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CreatorsApi
   */
  public creatorsCreatorIdLinksLinkIdDelete(linkId: number, creatorId: number, options?: AxiosRequestConfig) {
    return CreatorsApiFp(this.configuration)
      .creatorsCreatorIdLinksLinkIdDelete(linkId, creatorId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} linkId
   * @param {number} creatorId
   * @param {InlineObject10} [inlineObject10]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CreatorsApi
   */
  public creatorsCreatorIdLinksLinkIdPost(
    linkId: number,
    creatorId: number,
    inlineObject10?: InlineObject10,
    options?: AxiosRequestConfig,
  ) {
    return CreatorsApiFp(this.configuration)
      .creatorsCreatorIdLinksLinkIdPost(linkId, creatorId, inlineObject10, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} creatorId
   * @param {InlineObject9} [inlineObject9]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CreatorsApi
   */
  public creatorsCreatorIdLinksOrderPatch(
    creatorId: number,
    inlineObject9?: InlineObject9,
    options?: AxiosRequestConfig,
  ) {
    return CreatorsApiFp(this.configuration)
      .creatorsCreatorIdLinksOrderPatch(creatorId, inlineObject9, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} creatorId
   * @param {InlineObject11} [inlineObject11]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CreatorsApi
   */
  public creatorsCreatorIdLinksPost(creatorId: number, inlineObject11?: InlineObject11, options?: AxiosRequestConfig) {
    return CreatorsApiFp(this.configuration)
      .creatorsCreatorIdLinksPost(creatorId, inlineObject11, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} creatorId
   * @param {InlineObject12} [inlineObject12]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CreatorsApi
   */
  public creatorsCreatorIdPatch(creatorId: number, inlineObject12?: InlineObject12, options?: AxiosRequestConfig) {
    return CreatorsApiFp(this.configuration)
      .creatorsCreatorIdPatch(creatorId, inlineObject12, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CreatorsApi
   */
  public creatorsGet(options?: AxiosRequestConfig) {
    return CreatorsApiFp(this.configuration)
      .creatorsGet(options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {InlineObject13} [inlineObject13]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CreatorsApi
   */
  public creatorsPost(inlineObject13?: InlineObject13, options?: AxiosRequestConfig) {
    return CreatorsApiFp(this.configuration)
      .creatorsPost(inlineObject13, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * DebugTokenApi - axios parameter creator
 * @export
 */
export const DebugTokenApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    debugTokenGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/debugToken`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * DebugTokenApi - functional programming interface
 * @export
 */
export const DebugTokenApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = DebugTokenApiAxiosParamCreator(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async debugTokenGet(
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.debugTokenGet(options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * DebugTokenApi - factory interface
 * @export
 */
export const DebugTokenApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = DebugTokenApiFp(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    debugTokenGet(options?: any): AxiosPromise<object> {
      return localVarFp.debugTokenGet(options).then(request => request(axios, basePath));
    },
  };
};

/**
 * DebugTokenApi - object-oriented interface
 * @export
 * @class DebugTokenApi
 * @extends {BaseAPI}
 */
export class DebugTokenApi extends BaseAPI {
  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DebugTokenApi
   */
  public debugTokenGet(options?: AxiosRequestConfig) {
    return DebugTokenApiFp(this.configuration)
      .debugTokenGet(options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * FormsApi - axios parameter creator
 * @export
 */
export const FormsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    formsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/forms`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * FormsApi - functional programming interface
 * @export
 */
export const FormsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = FormsApiAxiosParamCreator(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async formsGet(
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.formsGet(options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * FormsApi - factory interface
 * @export
 */
export const FormsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = FormsApiFp(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    formsGet(options?: any): AxiosPromise<object> {
      return localVarFp.formsGet(options).then(request => request(axios, basePath));
    },
  };
};

/**
 * FormsApi - object-oriented interface
 * @export
 * @class FormsApi
 * @extends {BaseAPI}
 */
export class FormsApi extends BaseAPI {
  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FormsApi
   */
  public formsGet(options?: AxiosRequestConfig) {
    return FormsApiFp(this.configuration)
      .formsGet(options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * GoogeApi - axios parameter creator
 * @export
 */
export const GoogeApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * <br /><br /> <b>Authentication:</b> not required
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    googeDecodeTokenGet: async (token: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'token' is not null or undefined
      assertParamExists('googeDecodeTokenGet', 'token', token);
      const localVarPath = `/googe/decodeToken`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (token !== undefined) {
        localVarQueryParameter['token'] = token;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * GoogeApi - functional programming interface
 * @export
 */
export const GoogeApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = GoogeApiAxiosParamCreator(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> not required
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async googeDecodeTokenGet(
      token: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.googeDecodeTokenGet(token, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * GoogeApi - factory interface
 * @export
 */
export const GoogeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = GoogeApiFp(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> not required
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    googeDecodeTokenGet(token: string, options?: any): AxiosPromise<object> {
      return localVarFp.googeDecodeTokenGet(token, options).then(request => request(axios, basePath));
    },
  };
};

/**
 * GoogeApi - object-oriented interface
 * @export
 * @class GoogeApi
 * @extends {BaseAPI}
 */
export class GoogeApi extends BaseAPI {
  /**
   * <br /><br /> <b>Authentication:</b> not required
   * @param {string} token
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GoogeApi
   */
  public googeDecodeTokenGet(token: string, options?: AxiosRequestConfig) {
    return GoogeApiFp(this.configuration)
      .googeDecodeTokenGet(token, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * ImpersonateApi - axios parameter creator
 * @export
 */
export const ImpersonateApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    impersonateGet: async (userId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('impersonateGet', 'userId', userId);
      const localVarPath = `/impersonate`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (userId !== undefined) {
        localVarQueryParameter['userId'] = userId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ImpersonateApi - functional programming interface
 * @export
 */
export const ImpersonateApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ImpersonateApiAxiosParamCreator(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async impersonateGet(
      userId: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.impersonateGet(userId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * ImpersonateApi - factory interface
 * @export
 */
export const ImpersonateApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = ImpersonateApiFp(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    impersonateGet(userId: number, options?: any): AxiosPromise<object> {
      return localVarFp.impersonateGet(userId, options).then(request => request(axios, basePath));
    },
  };
};

/**
 * ImpersonateApi - object-oriented interface
 * @export
 * @class ImpersonateApi
 * @extends {BaseAPI}
 */
export class ImpersonateApi extends BaseAPI {
  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} userId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ImpersonateApi
   */
  public impersonateGet(userId: number, options?: AxiosRequestConfig) {
    return ImpersonateApiFp(this.configuration)
      .impersonateGet(userId, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * ModerationApi - axios parameter creator
 * @export
 */
export const ModerationApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    moderationChatsSpaceGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/moderation/chats/space`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} chatId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    moderationMessagesGet: async (chatId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'chatId' is not null or undefined
      assertParamExists('moderationMessagesGet', 'chatId', chatId);
      const localVarPath = `/moderation/messages`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (chatId !== undefined) {
        localVarQueryParameter['chatId'] = chatId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ModerationApi - functional programming interface
 * @export
 */
export const ModerationApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ModerationApiAxiosParamCreator(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async moderationChatsSpaceGet(
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InlineResponse20013>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.moderationChatsSpaceGet(options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} chatId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async moderationMessagesGet(
      chatId: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.moderationMessagesGet(chatId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * ModerationApi - factory interface
 * @export
 */
export const ModerationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = ModerationApiFp(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    moderationChatsSpaceGet(options?: any): AxiosPromise<Array<InlineResponse20013>> {
      return localVarFp.moderationChatsSpaceGet(options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} chatId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    moderationMessagesGet(chatId: number, options?: any): AxiosPromise<object> {
      return localVarFp.moderationMessagesGet(chatId, options).then(request => request(axios, basePath));
    },
  };
};

/**
 * ModerationApi - object-oriented interface
 * @export
 * @class ModerationApi
 * @extends {BaseAPI}
 */
export class ModerationApi extends BaseAPI {
  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ModerationApi
   */
  public moderationChatsSpaceGet(options?: AxiosRequestConfig) {
    return ModerationApiFp(this.configuration)
      .moderationChatsSpaceGet(options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} chatId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ModerationApi
   */
  public moderationMessagesGet(chatId: number, options?: AxiosRequestConfig) {
    return ModerationApiFp(this.configuration)
      .moderationMessagesGet(chatId, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * NotifyApi - axios parameter creator
 * @export
 */
export const NotifyApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject16} [inlineObject16]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    notifyPost: async (inlineObject16?: InlineObject16, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/notify`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(inlineObject16, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject14} [inlineObject14]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    notifyRemovePost: async (
      inlineObject14?: InlineObject14,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/notify/remove`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(inlineObject14, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * NotifyApi - functional programming interface
 * @export
 */
export const NotifyApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = NotifyApiAxiosParamCreator(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject16} [inlineObject16]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async notifyPost(
      inlineObject16?: InlineObject16,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.notifyPost(inlineObject16, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject14} [inlineObject14]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async notifyRemovePost(
      inlineObject14?: InlineObject14,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.notifyRemovePost(inlineObject14, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * NotifyApi - factory interface
 * @export
 */
export const NotifyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = NotifyApiFp(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject16} [inlineObject16]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    notifyPost(inlineObject16?: InlineObject16, options?: any): AxiosPromise<object> {
      return localVarFp.notifyPost(inlineObject16, options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject14} [inlineObject14]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    notifyRemovePost(inlineObject14?: InlineObject14, options?: any): AxiosPromise<object> {
      return localVarFp.notifyRemovePost(inlineObject14, options).then(request => request(axios, basePath));
    },
  };
};

/**
 * NotifyApi - object-oriented interface
 * @export
 * @class NotifyApi
 * @extends {BaseAPI}
 */
export class NotifyApi extends BaseAPI {
  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {InlineObject16} [inlineObject16]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotifyApi
   */
  public notifyPost(inlineObject16?: InlineObject16, options?: AxiosRequestConfig) {
    return NotifyApiFp(this.configuration)
      .notifyPost(inlineObject16, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {InlineObject14} [inlineObject14]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotifyApi
   */
  public notifyRemovePost(inlineObject14?: InlineObject14, options?: AxiosRequestConfig) {
    return NotifyApiFp(this.configuration)
      .notifyRemovePost(inlineObject14, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * Notify0Api - axios parameter creator
 * @export
 */
export const Notify0ApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject15} [inlineObject15]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    notify0Post: async (inlineObject15?: InlineObject15, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/notify_0`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(inlineObject15, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * Notify0Api - functional programming interface
 * @export
 */
export const Notify0ApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = Notify0ApiAxiosParamCreator(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject15} [inlineObject15]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async notify0Post(
      inlineObject15?: InlineObject15,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20014>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.notify0Post(inlineObject15, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * Notify0Api - factory interface
 * @export
 */
export const Notify0ApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = Notify0ApiFp(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject15} [inlineObject15]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    notify0Post(inlineObject15?: InlineObject15, options?: any): AxiosPromise<InlineResponse20014> {
      return localVarFp.notify0Post(inlineObject15, options).then(request => request(axios, basePath));
    },
  };
};

/**
 * Notify0Api - object-oriented interface
 * @export
 * @class Notify0Api
 * @extends {BaseAPI}
 */
export class Notify0Api extends BaseAPI {
  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {InlineObject15} [inlineObject15]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof Notify0Api
   */
  public notify0Post(inlineObject15?: InlineObject15, options?: AxiosRequestConfig) {
    return Notify0ApiFp(this.configuration)
      .notify0Post(inlineObject15, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * PlatformApi - axios parameter creator
 * @export
 */
export const PlatformApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {'onboarding' | 'realtime' | 'afterEvent'} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    platformPostsGet: async (
      type?: 'onboarding' | 'realtime' | 'afterEvent',
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/platform/posts`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (type !== undefined) {
        localVarQueryParameter['type'] = type;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject17} [inlineObject17]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    platformPostsOrderPost: async (
      inlineObject17?: InlineObject17,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/platform/posts/order`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(inlineObject17, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject19} [inlineObject19]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    platformPostsPost: async (
      inlineObject19?: InlineObject19,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/platform/posts`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(inlineObject19, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} postId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    platformPostsPostIdDelete: async (postId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'postId' is not null or undefined
      assertParamExists('platformPostsPostIdDelete', 'postId', postId);
      const localVarPath = `/platform/posts/{postId}`.replace(`{${'postId'}}`, encodeURIComponent(String(postId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} postId
     * @param {InlineObject18} [inlineObject18]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    platformPostsPostIdPatch: async (
      postId: number,
      inlineObject18?: InlineObject18,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'postId' is not null or undefined
      assertParamExists('platformPostsPostIdPatch', 'postId', postId);
      const localVarPath = `/platform/posts/{postId}`.replace(`{${'postId'}}`, encodeURIComponent(String(postId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(inlineObject18, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} postId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    platformPostsPostIdPublishPost: async (postId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'postId' is not null or undefined
      assertParamExists('platformPostsPostIdPublishPost', 'postId', postId);
      const localVarPath = `/platform/posts/{postId}/publish`.replace(
        `{${'postId'}}`,
        encodeURIComponent(String(postId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} postId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    platformPostsPostIdTestPost: async (postId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'postId' is not null or undefined
      assertParamExists('platformPostsPostIdTestPost', 'postId', postId);
      const localVarPath = `/platform/posts/{postId}/test`.replace(`{${'postId'}}`, encodeURIComponent(String(postId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PlatformApi - functional programming interface
 * @export
 */
export const PlatformApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PlatformApiAxiosParamCreator(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {'onboarding' | 'realtime' | 'afterEvent'} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async platformPostsGet(
      type?: 'onboarding' | 'realtime' | 'afterEvent',
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InlineResponse20017>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.platformPostsGet(type, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject17} [inlineObject17]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async platformPostsOrderPost(
      inlineObject17?: InlineObject17,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.platformPostsOrderPost(inlineObject17, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject19} [inlineObject19]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async platformPostsPost(
      inlineObject19?: InlineObject19,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20016>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.platformPostsPost(inlineObject19, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} postId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async platformPostsPostIdDelete(
      postId: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.platformPostsPostIdDelete(postId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} postId
     * @param {InlineObject18} [inlineObject18]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async platformPostsPostIdPatch(
      postId: number,
      inlineObject18?: InlineObject18,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20016>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.platformPostsPostIdPatch(
        postId,
        inlineObject18,
        options,
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} postId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async platformPostsPostIdPublishPost(
      postId: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20015>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.platformPostsPostIdPublishPost(postId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} postId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async platformPostsPostIdTestPost(
      postId: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.platformPostsPostIdTestPost(postId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * PlatformApi - factory interface
 * @export
 */
export const PlatformApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = PlatformApiFp(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {'onboarding' | 'realtime' | 'afterEvent'} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    platformPostsGet(
      type?: 'onboarding' | 'realtime' | 'afterEvent',
      options?: any,
    ): AxiosPromise<Array<InlineResponse20017>> {
      return localVarFp.platformPostsGet(type, options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject17} [inlineObject17]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    platformPostsOrderPost(inlineObject17?: InlineObject17, options?: any): AxiosPromise<object> {
      return localVarFp.platformPostsOrderPost(inlineObject17, options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject19} [inlineObject19]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    platformPostsPost(inlineObject19?: InlineObject19, options?: any): AxiosPromise<InlineResponse20016> {
      return localVarFp.platformPostsPost(inlineObject19, options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} postId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    platformPostsPostIdDelete(postId: number, options?: any): AxiosPromise<object> {
      return localVarFp.platformPostsPostIdDelete(postId, options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} postId
     * @param {InlineObject18} [inlineObject18]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    platformPostsPostIdPatch(
      postId: number,
      inlineObject18?: InlineObject18,
      options?: any,
    ): AxiosPromise<InlineResponse20016> {
      return localVarFp
        .platformPostsPostIdPatch(postId, inlineObject18, options)
        .then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} postId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    platformPostsPostIdPublishPost(postId: number, options?: any): AxiosPromise<InlineResponse20015> {
      return localVarFp.platformPostsPostIdPublishPost(postId, options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} postId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    platformPostsPostIdTestPost(postId: number, options?: any): AxiosPromise<object> {
      return localVarFp.platformPostsPostIdTestPost(postId, options).then(request => request(axios, basePath));
    },
  };
};

/**
 * PlatformApi - object-oriented interface
 * @export
 * @class PlatformApi
 * @extends {BaseAPI}
 */
export class PlatformApi extends BaseAPI {
  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {'onboarding' | 'realtime' | 'afterEvent'} [type]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlatformApi
   */
  public platformPostsGet(type?: 'onboarding' | 'realtime' | 'afterEvent', options?: AxiosRequestConfig) {
    return PlatformApiFp(this.configuration)
      .platformPostsGet(type, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {InlineObject17} [inlineObject17]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlatformApi
   */
  public platformPostsOrderPost(inlineObject17?: InlineObject17, options?: AxiosRequestConfig) {
    return PlatformApiFp(this.configuration)
      .platformPostsOrderPost(inlineObject17, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {InlineObject19} [inlineObject19]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlatformApi
   */
  public platformPostsPost(inlineObject19?: InlineObject19, options?: AxiosRequestConfig) {
    return PlatformApiFp(this.configuration)
      .platformPostsPost(inlineObject19, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} postId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlatformApi
   */
  public platformPostsPostIdDelete(postId: number, options?: AxiosRequestConfig) {
    return PlatformApiFp(this.configuration)
      .platformPostsPostIdDelete(postId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} postId
   * @param {InlineObject18} [inlineObject18]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlatformApi
   */
  public platformPostsPostIdPatch(postId: number, inlineObject18?: InlineObject18, options?: AxiosRequestConfig) {
    return PlatformApiFp(this.configuration)
      .platformPostsPostIdPatch(postId, inlineObject18, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} postId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlatformApi
   */
  public platformPostsPostIdPublishPost(postId: number, options?: AxiosRequestConfig) {
    return PlatformApiFp(this.configuration)
      .platformPostsPostIdPublishPost(postId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} postId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlatformApi
   */
  public platformPostsPostIdTestPost(postId: number, options?: AxiosRequestConfig) {
    return PlatformApiFp(this.configuration)
      .platformPostsPostIdTestPost(postId, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * SpacesApi - axios parameter creator
 * @export
 */
export const SpacesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Список всех спейсов <br /><br /> <b>Authentication:</b> required
     * @summary Список всех спейсов
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/spaces`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdDelete: async (spaceId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'spaceId' is not null or undefined
      assertParamExists('spacesSpaceIdDelete', 'spaceId', spaceId);
      const localVarPath = `/spaces/{spaceId}`.replace(`{${'spaceId'}}`, encodeURIComponent(String(spaceId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdPriceGet: async (spaceId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'spaceId' is not null or undefined
      assertParamExists('spacesSpaceIdPriceGet', 'spaceId', spaceId);
      const localVarPath = `/spaces/{spaceId}/price`.replace(`{${'spaceId'}}`, encodeURIComponent(String(spaceId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {InlineObject20} [inlineObject20]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdPricePatch: async (
      spaceId: number,
      inlineObject20?: InlineObject20,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'spaceId' is not null or undefined
      assertParamExists('spacesSpaceIdPricePatch', 'spaceId', spaceId);
      const localVarPath = `/spaces/{spaceId}/price`.replace(`{${'spaceId'}}`, encodeURIComponent(String(spaceId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(inlineObject20, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdRevokePost: async (spaceId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'spaceId' is not null or undefined
      assertParamExists('spacesSpaceIdRevokePost', 'spaceId', spaceId);
      const localVarPath = `/spaces/{spaceId}/revoke`.replace(`{${'spaceId'}}`, encodeURIComponent(String(spaceId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * SpacesApi - functional programming interface
 * @export
 */
export const SpacesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = SpacesApiAxiosParamCreator(configuration);
  return {
    /**
     * Список всех спейсов <br /><br /> <b>Authentication:</b> required
     * @summary Список всех спейсов
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async spacesGet(
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InlineResponse20020>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.spacesGet(options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async spacesSpaceIdDelete(
      spaceId: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.spacesSpaceIdDelete(spaceId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async spacesSpaceIdPriceGet(
      spaceId: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20018>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.spacesSpaceIdPriceGet(spaceId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {InlineObject20} [inlineObject20]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async spacesSpaceIdPricePatch(
      spaceId: number,
      inlineObject20?: InlineObject20,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20019>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.spacesSpaceIdPricePatch(
        spaceId,
        inlineObject20,
        options,
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async spacesSpaceIdRevokePost(
      spaceId: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.spacesSpaceIdRevokePost(spaceId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * SpacesApi - factory interface
 * @export
 */
export const SpacesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = SpacesApiFp(configuration);
  return {
    /**
     * Список всех спейсов <br /><br /> <b>Authentication:</b> required
     * @summary Список всех спейсов
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesGet(options?: any): AxiosPromise<Array<InlineResponse20020>> {
      return localVarFp.spacesGet(options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdDelete(spaceId: number, options?: any): AxiosPromise<object> {
      return localVarFp.spacesSpaceIdDelete(spaceId, options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdPriceGet(spaceId: number, options?: any): AxiosPromise<InlineResponse20018> {
      return localVarFp.spacesSpaceIdPriceGet(spaceId, options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {InlineObject20} [inlineObject20]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdPricePatch(
      spaceId: number,
      inlineObject20?: InlineObject20,
      options?: any,
    ): AxiosPromise<InlineResponse20019> {
      return localVarFp
        .spacesSpaceIdPricePatch(spaceId, inlineObject20, options)
        .then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdRevokePost(spaceId: number, options?: any): AxiosPromise<object> {
      return localVarFp.spacesSpaceIdRevokePost(spaceId, options).then(request => request(axios, basePath));
    },
  };
};

/**
 * SpacesApi - object-oriented interface
 * @export
 * @class SpacesApi
 * @extends {BaseAPI}
 */
export class SpacesApi extends BaseAPI {
  /**
   * Список всех спейсов <br /><br /> <b>Authentication:</b> required
   * @summary Список всех спейсов
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SpacesApi
   */
  public spacesGet(options?: AxiosRequestConfig) {
    return SpacesApiFp(this.configuration)
      .spacesGet(options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} spaceId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SpacesApi
   */
  public spacesSpaceIdDelete(spaceId: number, options?: AxiosRequestConfig) {
    return SpacesApiFp(this.configuration)
      .spacesSpaceIdDelete(spaceId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} spaceId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SpacesApi
   */
  public spacesSpaceIdPriceGet(spaceId: number, options?: AxiosRequestConfig) {
    return SpacesApiFp(this.configuration)
      .spacesSpaceIdPriceGet(spaceId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} spaceId
   * @param {InlineObject20} [inlineObject20]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SpacesApi
   */
  public spacesSpaceIdPricePatch(spaceId: number, inlineObject20?: InlineObject20, options?: AxiosRequestConfig) {
    return SpacesApiFp(this.configuration)
      .spacesSpaceIdPricePatch(spaceId, inlineObject20, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} spaceId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SpacesApi
   */
  public spacesSpaceIdRevokePost(spaceId: number, options?: AxiosRequestConfig) {
    return SpacesApiFp(this.configuration)
      .spacesSpaceIdRevokePost(spaceId, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * TagsApi - axios parameter creator
 * @export
 */
export const TagsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tagsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/tags`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject23} [inlineObject23]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tagsPost: async (inlineObject23?: InlineObject23, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/tags`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(inlineObject23, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} tagId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tagsTagIdDelete: async (tagId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'tagId' is not null or undefined
      assertParamExists('tagsTagIdDelete', 'tagId', tagId);
      const localVarPath = `/tags/{tagId}`.replace(`{${'tagId'}}`, encodeURIComponent(String(tagId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} tagId
     * @param {InlineObject22} [inlineObject22]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tagsTagIdPost: async (
      tagId: number,
      inlineObject22?: InlineObject22,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'tagId' is not null or undefined
      assertParamExists('tagsTagIdPost', 'tagId', tagId);
      const localVarPath = `/tags/{tagId}`.replace(`{${'tagId'}}`, encodeURIComponent(String(tagId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(inlineObject22, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {number} tagId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tagsTagIdSpacesSpaceIdDelete: async (
      spaceId: number,
      tagId: number,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'spaceId' is not null or undefined
      assertParamExists('tagsTagIdSpacesSpaceIdDelete', 'spaceId', spaceId);
      // verify required parameter 'tagId' is not null or undefined
      assertParamExists('tagsTagIdSpacesSpaceIdDelete', 'tagId', tagId);
      const localVarPath = `/tags/{tagId}/spaces/{spaceId}`
        .replace(`{${'spaceId'}}`, encodeURIComponent(String(spaceId)))
        .replace(`{${'tagId'}}`, encodeURIComponent(String(tagId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {number} tagId
     * @param {InlineObject21} [inlineObject21]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tagsTagIdSpacesSpaceIdPost: async (
      spaceId: number,
      tagId: number,
      inlineObject21?: InlineObject21,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'spaceId' is not null or undefined
      assertParamExists('tagsTagIdSpacesSpaceIdPost', 'spaceId', spaceId);
      // verify required parameter 'tagId' is not null or undefined
      assertParamExists('tagsTagIdSpacesSpaceIdPost', 'tagId', tagId);
      const localVarPath = `/tags/{tagId}/spaces/{spaceId}`
        .replace(`{${'spaceId'}}`, encodeURIComponent(String(spaceId)))
        .replace(`{${'tagId'}}`, encodeURIComponent(String(tagId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(inlineObject21, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * TagsApi - functional programming interface
 * @export
 */
export const TagsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = TagsApiAxiosParamCreator(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tagsGet(
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InlineResponse20022>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.tagsGet(options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject23} [inlineObject23]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tagsPost(
      inlineObject23?: InlineObject23,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20022>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.tagsPost(inlineObject23, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} tagId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tagsTagIdDelete(
      tagId: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.tagsTagIdDelete(tagId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} tagId
     * @param {InlineObject22} [inlineObject22]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tagsTagIdPost(
      tagId: number,
      inlineObject22?: InlineObject22,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20022>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.tagsTagIdPost(tagId, inlineObject22, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {number} tagId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tagsTagIdSpacesSpaceIdDelete(
      spaceId: number,
      tagId: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InlineResponse20021>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.tagsTagIdSpacesSpaceIdDelete(spaceId, tagId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {number} tagId
     * @param {InlineObject21} [inlineObject21]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tagsTagIdSpacesSpaceIdPost(
      spaceId: number,
      tagId: number,
      inlineObject21?: InlineObject21,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20021>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.tagsTagIdSpacesSpaceIdPost(
        spaceId,
        tagId,
        inlineObject21,
        options,
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * TagsApi - factory interface
 * @export
 */
export const TagsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = TagsApiFp(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tagsGet(options?: any): AxiosPromise<Array<InlineResponse20022>> {
      return localVarFp.tagsGet(options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject23} [inlineObject23]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tagsPost(inlineObject23?: InlineObject23, options?: any): AxiosPromise<InlineResponse20022> {
      return localVarFp.tagsPost(inlineObject23, options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} tagId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tagsTagIdDelete(tagId: number, options?: any): AxiosPromise<object> {
      return localVarFp.tagsTagIdDelete(tagId, options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} tagId
     * @param {InlineObject22} [inlineObject22]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tagsTagIdPost(tagId: number, inlineObject22?: InlineObject22, options?: any): AxiosPromise<InlineResponse20022> {
      return localVarFp.tagsTagIdPost(tagId, inlineObject22, options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {number} tagId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tagsTagIdSpacesSpaceIdDelete(
      spaceId: number,
      tagId: number,
      options?: any,
    ): AxiosPromise<Array<InlineResponse20021>> {
      return localVarFp.tagsTagIdSpacesSpaceIdDelete(spaceId, tagId, options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {number} tagId
     * @param {InlineObject21} [inlineObject21]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tagsTagIdSpacesSpaceIdPost(
      spaceId: number,
      tagId: number,
      inlineObject21?: InlineObject21,
      options?: any,
    ): AxiosPromise<InlineResponse20021> {
      return localVarFp
        .tagsTagIdSpacesSpaceIdPost(spaceId, tagId, inlineObject21, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * TagsApi - object-oriented interface
 * @export
 * @class TagsApi
 * @extends {BaseAPI}
 */
export class TagsApi extends BaseAPI {
  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TagsApi
   */
  public tagsGet(options?: AxiosRequestConfig) {
    return TagsApiFp(this.configuration)
      .tagsGet(options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {InlineObject23} [inlineObject23]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TagsApi
   */
  public tagsPost(inlineObject23?: InlineObject23, options?: AxiosRequestConfig) {
    return TagsApiFp(this.configuration)
      .tagsPost(inlineObject23, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} tagId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TagsApi
   */
  public tagsTagIdDelete(tagId: number, options?: AxiosRequestConfig) {
    return TagsApiFp(this.configuration)
      .tagsTagIdDelete(tagId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} tagId
   * @param {InlineObject22} [inlineObject22]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TagsApi
   */
  public tagsTagIdPost(tagId: number, inlineObject22?: InlineObject22, options?: AxiosRequestConfig) {
    return TagsApiFp(this.configuration)
      .tagsTagIdPost(tagId, inlineObject22, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} spaceId
   * @param {number} tagId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TagsApi
   */
  public tagsTagIdSpacesSpaceIdDelete(spaceId: number, tagId: number, options?: AxiosRequestConfig) {
    return TagsApiFp(this.configuration)
      .tagsTagIdSpacesSpaceIdDelete(spaceId, tagId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} spaceId
   * @param {number} tagId
   * @param {InlineObject21} [inlineObject21]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TagsApi
   */
  public tagsTagIdSpacesSpaceIdPost(
    spaceId: number,
    tagId: number,
    inlineObject21?: InlineObject21,
    options?: AxiosRequestConfig,
  ) {
    return TagsApiFp(this.configuration)
      .tagsTagIdSpacesSpaceIdPost(spaceId, tagId, inlineObject21, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * UndoFreeBuyApi - axios parameter creator
 * @export
 */
export const UndoFreeBuyApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject24} [inlineObject24]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    undoFreeBuyPost: async (
      inlineObject24?: InlineObject24,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/undoFreeBuy`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(inlineObject24, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * UndoFreeBuyApi - functional programming interface
 * @export
 */
export const UndoFreeBuyApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = UndoFreeBuyApiAxiosParamCreator(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject24} [inlineObject24]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async undoFreeBuyPost(
      inlineObject24?: InlineObject24,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.undoFreeBuyPost(inlineObject24, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * UndoFreeBuyApi - factory interface
 * @export
 */
export const UndoFreeBuyApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = UndoFreeBuyApiFp(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject24} [inlineObject24]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    undoFreeBuyPost(inlineObject24?: InlineObject24, options?: any): AxiosPromise<object> {
      return localVarFp.undoFreeBuyPost(inlineObject24, options).then(request => request(axios, basePath));
    },
  };
};

/**
 * UndoFreeBuyApi - object-oriented interface
 * @export
 * @class UndoFreeBuyApi
 * @extends {BaseAPI}
 */
export class UndoFreeBuyApi extends BaseAPI {
  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {InlineObject24} [inlineObject24]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UndoFreeBuyApi
   */
  public undoFreeBuyPost(inlineObject24?: InlineObject24, options?: AxiosRequestConfig) {
    return UndoFreeBuyApiFp(this.configuration)
      .undoFreeBuyPost(inlineObject24, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {boolean} [filter]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersGet: async (filter?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/users`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (filter !== undefined) {
        localVarQueryParameter['filter'] = filter;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} userId
     * @param {InlineObject25} [inlineObject25]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersUserIdSendPlatformMessagePost: async (
      userId: number,
      inlineObject25?: InlineObject25,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('usersUserIdSendPlatformMessagePost', 'userId', userId);
      const localVarPath = `/users/{userId}/sendPlatformMessage`.replace(
        `{${'userId'}}`,
        encodeURIComponent(String(userId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(inlineObject25, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {boolean} [filter]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async usersGet(
      filter?: boolean,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InlineResponse20023>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.usersGet(filter, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} userId
     * @param {InlineObject25} [inlineObject25]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async usersUserIdSendPlatformMessagePost(
      userId: number,
      inlineObject25?: InlineObject25,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.usersUserIdSendPlatformMessagePost(
        userId,
        inlineObject25,
        options,
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = UsersApiFp(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {boolean} [filter]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersGet(filter?: boolean, options?: any): AxiosPromise<Array<InlineResponse20023>> {
      return localVarFp.usersGet(filter, options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} userId
     * @param {InlineObject25} [inlineObject25]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersUserIdSendPlatformMessagePost(
      userId: number,
      inlineObject25?: InlineObject25,
      options?: any,
    ): AxiosPromise<object> {
      return localVarFp
        .usersUserIdSendPlatformMessagePost(userId, inlineObject25, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {boolean} [filter]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  public usersGet(filter?: boolean, options?: AxiosRequestConfig) {
    return UsersApiFp(this.configuration)
      .usersGet(filter, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} userId
   * @param {InlineObject25} [inlineObject25]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  public usersUserIdSendPlatformMessagePost(
    userId: number,
    inlineObject25?: InlineObject25,
    options?: AxiosRequestConfig,
  ) {
    return UsersApiFp(this.configuration)
      .usersUserIdSendPlatformMessagePost(userId, inlineObject25, options)
      .then(request => request(this.axios, this.basePath));
  }
}
